/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import {
    Avatar,
    Button,
    Drawer,
    Grid,
    TextField,
    Theme,
    Typography,
    AppBar,
    Toolbar,
    CircularProgress, 
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControlLabel,
    Checkbox,
    //Tooltip    
} from "@material-ui/core";
import { Hidden } from '@mui/material';
import { makeStyles, createStyles } from "@material-ui/styles";
import React, { useContext, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import {
    //Brightness1,
    RoomRounded,
    Star,
    //StarRounded,
} from "@material-ui/icons";
//import { AnnounceImageList } from "./components/AnnounceImageList";
//import PermDeviceInformationIcon from "@material-ui/icons/PermDeviceInformation";
//import { ReservationCard } from "./components/ReservationCard";
//import { CommentCard } from "./components/CommentCard";
//import { AfriqGreyButton } from "../components/AfriqButton";
import { AnnouncesService } from "./services/AnnounceService";
import * as Annouce from "../../Services/AnnounceService";
import {
    ILocation,
    IReview,
    ReviewInputs,
    IAnnounce,
    IEquipment
} from "../../utils/AnnounceInterfaces";
import {
    announceDefaultValue,
    locationDefaultValue,
    reviewInputDefaultValue,
} from "../../utils/defaultNullValues";
import { createMarkup, getDayNumberProm, useQuery } from "../../utils/App";
//import SessionHandler from "../../https/SessionHandler";
import { CurrencyContext, UserContext } from "../../contexts/AppContext";
import { Pagination, Stack } from "@mui/material";
//import { Map } from "../Map/Map";
import { serverConfig } from "../../utils/config";
import PropagateLoader from "react-spinners/PropagateLoader";
import "react-day-picker/lib/style.css";
import paw from "../../images/paw.svg";
import avatar_empty from "../../images/avatar_empty.png";
import "react-calendar/dist/Calendar.css";
//import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import moment from "moment";
//import { PropertyService } from "../Properties/services/PropertyService";
import CelebrationIcon from "@mui/icons-material/Celebration";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import CardTravelIcon from "@material-ui/icons/CardTravel";
import HotelIcon from '@mui/icons-material/Hotel';
import BathtubIcon from "../../images/capturebath.png";
import LuggageIcon from "../../images/captureluggage.png";
import carDoorIcon from "../../images/cardoors.png";
import traveller from "../../images/traveller.png";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import { HashLink } from "react-router-hash-link";
import CloseIcon from "@mui/icons-material/Close";
import { CountryService } from "../Admin/Countries/services/EquipmentCountry";
import { ConvertedDeviseWithMoneySign } from "../../utils/CurrencyConvertFunction";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { EStatus, ERoles } from "../../utils/enum";
import MapIcon from "@mui/icons-material/Map";
import { Helmet } from "react-helmet-async";
import EditIcon from "@material-ui/icons/Edit";
import { Link } from "react-router-dom";
import { StickyBarContactButton } from "../components/ContactButton";
import DownloadImages from "./ImageDownloader";
import VisibilityIcon from '@mui/icons-material/Visibility';
//import PlaceIcon from '@mui/icons-material/Place';
import CustomHidden from "../components/CustomHidden";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HotelCarousel from "./HotelCarousel";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
//import { IUserRegister, RegisterService } from "../components/Register/services/RegisterService";
//import { fileToBase64 } from "../../utils/App";
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LanguageIcon from '@mui/icons-material/Language';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import CallIcon from '@mui/icons-material/Call';
//import LocationOnIcon from '@mui/icons-material/LocationOn';
//import YouTubeIcon from '@mui/icons-material/YouTube';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
//import { CountryPhoneList } from "../../utils/CountryList";
//import { SelectEndornmentNation } from "../components/Register/TextFieldNation";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
//import FindCircuitsPopup from "./components/searchComponent/FindCircuitsPopup";
//import { getErrorLabel, UserErrorMessage } from "../../utils/UserInterfaces";
//import { ISnackbar } from "../../utils/enum/snackBarType";
import { LoginDialog } from "../components/Login/LoginDialog";
import { RegisterDialog } from "../components/Register/RegisterDialog";
import QRCodeGenerator from "./components/QRCodeGenerator";
import IosShareIcon from '@mui/icons-material/IosShare';
//import AdSenseAd from "../components/AdSenseAd";
import { AdPicturesCarousel } from "../components/AdPicturesCarousel";
import StarRating from "../components/StarRating";
import MasterCard_logo from "../../images/MasterCard_logo.jpg";
import MTNMobileMoney_logo from "../../images/MTNMobileMoney_logo.jpg";
import OrangeMoney_logo from "../../images/OrangeMoney_logo.jpg";
import PayPal_logo from "../../images/PayPal_logo.jpg";
import Visa2_logo from "../../images/Visa2_logo.jpg";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { getCountryCode } from "../../utils/countryCodes";
//import AnnounceImageList from "./components/AnnounceImageList";
const AnnounceImageList = React.lazy(() => import("./components/AnnounceImageList"));
const ReservationCard = React.lazy(() => import("./components/ReservationCard"));
const CommentCard = React.lazy(() => import("./components/CommentCard"));
const Map = React.lazy(() => import("../Map/Map"));

const localizer = momentLocalizer(moment);
const Env = serverConfig;


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            paddingTop: 54,
            paddingBottom: 54,
            [theme.breakpoints.down(1025)]: {
                paddingTop: 10,
                overflow: "hidden",
            },
        },
        videoIframe: {
            width: "50%", /* Half of the screen width */
            height: "100%", /* Full screen height */
            [theme.breakpoints.down(768)]: {
                width: "100%", /* Full screen width on small screens */
            },
        },
        font: {
            color: "#7D7D57",
        },
        btn_icon: {
            marginRight: 10,
        },
        btn_grey: {
            textTransform: "none",
            "&.MuiButton-root": {
                color: "#7D7D57",
            },
        },
        section: {
            marginTop: 25,
            width: "100%",
        },

        btnComment: {
            textTransform: "none",
            "&:hover": {
                background: "#B5551B !important",
            },
        },
        btn_red: {
            padding: "9px 14px",
            marginBottom: 20,
            backgroundColor: "#890608",
            borderRadius: 100,
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        btn_red_appbar: {
            padding: "9px 14px",
            // marginBottom: 20,
            backgroundColor: "#890608",
            borderRadius: 100,
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        localisationPropert: {
            lineHeight: "25px",
        },
        btn_cancel: {
            padding: "9px 14px",
            marginBottom: 20,
            marginLeft: 20,
            borderRadius: 100,
            backgroundColor: "#AAAAAA",
            "&:hover": {
                background: "#B5551B",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        refundItem: {
            lineHeight: "25px",
            fontWeight: 400,
            fontSize: 14,
        },
        comment_card: {
            marginBottom: 32,
        },
        loader: {
            position: "absolute",
            top: "50%",
            left: "50%",
        },
        svgList: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
        },
        icon: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginRight: 40,
            "&:last-child": {
                marginRight: 0,
            },
            [theme.breakpoints.down("sm")]: {
                marginRight: 10,
            },
        },
        titleDialog: {
            padding: "5px 10px!important",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        },
        promotionDiscount: {
            padding: 9,
            background: "rgb(238, 186, 65)",
            color: "white",
        },
        listAttribut: {
            background: "#EEBA41",
            padding: 8,
            borderRadius: 2,
            marginRight: "10px !important",
            "&:last-child": {
                marginRight: "0px !important",
            },
        },
        ambassador: {
            background: "#ffffff",
            padding: 8,
            borderRadius: 2,
            marginRight: "10px !important",
            boxShadow:
                "0px 1px 2px rgb(0 0 0 / 6%), 0px 4px 12px rgb(0 0 0 / 2%) !important",
        },
        promotionTitle: {
            color: "red",
        },
        promotionDates: {
            color: "rgb(238, 186, 65)",
        },
        radius: {
            width: 80,
            height: 80,
            padding: 24,
            border: "1px solid #eaeaea",
            borderRadius: "50%",
            marginBottom: 15,
        },
        reservationAppBar: {
            // position: "fixed",
            top: "auto",
            bottom: 0,
            backgroundColor: "#FFF",
            color: "#000",
            // width: "100%",
        },
        light: {
            fontWeight: 300,
        },
        avatar: {
            display: "flex",
            marginBottom: 33,
        },
        avatarImg: {
            width: 120,
            height: 120,
        },
        button: {
            background: "#890608",
            color: "white",
            borderRadius: 4,  // Slightly rounded corners
            fontFamily: "Josefin Sans",
            fontSize: 12,
            textTransform: "capitalize",
            padding: "4px 7px",
            margin: "0 auto 0 auto",
            display: "flex",
            justifyContent: "center", // Center align content
            "&:hover": {
                background: "#B5551B",
            },
            "&:disabled": {
                color: "#999",
            },
            width: "auto", // Ensures button stretches to fit content
        },
        contentDialog: {
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            paddingTop: "20px !important",
            paddingBottom: "20px",
        },
        actionsDialog: {
            padding: "10px !important",
        },
        host: {
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
            marginLeft: 28,
        },
        title: {
            color: "#4D4F5C",
            fontSize: 18,
            fontWeight: 500,
            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
        },
        annuler: {
            borderRadius: "20px !important",
            textTransform: "capitalize",
            background: "#2F45B51A!important",
            color: "#000 !important",

            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol" !important',
            boxShadow: "none!important",
        },
        valider: {
            borderRadius: "20px !important",
            background: "#890608!important",
            color: "white !important",
            fontFamily:
                'Josefin Sans,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol" !important',
            boxShadow: "none!important",
        },
        hostButton: {
            padding: "9px 24px",
            textTransform: "none",
            background: "none",
            border: "1px solid #000000",
            borderRadius: 10,
            color: "#000000",
            marginTop: 33,
        },
        price: {
            color: "#EA7606",
            fontSize: 20,
        },
        map: {
            marginBottom: 120,
        },
        drawerPaperMap: {
            borderTopRightRadius: 10,
            borderTopLeftRadius: 10,
            borderBottomRightRadius: 0,
            borderBottomRadius: 0,
            padding: 10,
            maxHeight: "85%",
            borderBottom: "1px solid rgba(0, 0, 0, 0.3)",
        },
        h4Style: {
            fontWeight: "normal", // Set font weight to normal (not bold)
        },
        stickyFilterBar: {
            position: 'fixed',
            top: 75,
            left: 0,    // Ensures the sticky bar aligns flush with the left edge of the viewport
            right: 0,   // Ensures the sticky bar aligns flush with the right edge of the viewport
            width: '100%',
            backgroundColor: 'white',
            zIndex: 1000,
            boxShadow: '0px 4px 2px -2px gray',
            padding: '5px',
            display: 'flex',
            justifyContent: 'center', // Center align content horizontally
            alignItems: 'center',    // Center align vertically
            height: 40,
        },
        breadcrumbNav: {
            marginTop: "30px",
            fontSize: "15px",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            overflow: "hidden",
          },
          breadcrumbList: {
            listStyle: "none",
            margin: 0,
            padding: 0,
            display: "flex",
            flexDirection: "row-reverse", // Reverse for mobile screens
            alignItems: "center",
            flexWrap: "wrap",
            [theme.breakpoints.up("md")]: {
              flexDirection: "row", // Normal direction for large screens
            },
          },
          breadcrumbListMobile: {
            display: "flex",
            flexDirection: "column", // Ensures items are stacked vertically
            paddingLeft: 0, // Removes default list padding
            listStyle: "none", // Removes default bullet points
        },
          breadcrumbItem: {
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          breadcrumbItemLarge: {
            display: "none", // Hide for mobile screens
            [theme.breakpoints.up("md")]: {
              display: "flex", // Show for large screens
            },
          },
          phoneNumber: {
            color: "blue",
            textDecoration: "underline",
            cursor: "pointer",
        },
          breadcrumbItemMobile: {
            display: "flex",
            alignItems: "center",
            marginBottom: "8px"
        },
          breadcrumbLink: {
            fontWeight: "bold",
            color: "#890608", // Link color
            textDecoration: "none",
            maxWidth: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          separator: {
            color: "#000", // Separator color
            fontWeight: "bold",
            marginLeft: "5px",
            marginRight: "5px",
          },
          locationIcon: {
            marginRight: "5px",
            color: "#000", // Icon color
           
          },
          propertyName: {            
            color: "#000", // Property name color
          },
          input: {
            "&::placeholder": {
                textOverflow: "ellipsis !important",
                color: "#000000",

                opacity: 10,
            },            
        },
        textField: {
            "&::placeholder": {
                color: "#000",
            },
            marginTop: 15,
            marginBottom: 15,
        }, 
        submit: {
            width: "80%",
            backgroundColor: "#890608",
            borderRadius: 100,
            "&:hover": {
                background: "#EA7606",
            },
            "&.MuiButton-root": {
                color: "white",
                textTransform: "capitalize",
            },
        },
        "@global": {
            ".text_body": {
                lineHeight: "25px",
                fontWeight: 400,
                fontSize: 14,
            },
            ".react-calendar": {
                boxShadow: "0 30px 40px 0 rgb(16 36 94 / 20%)",
                border: "none",
                width: "-webkit-fill-available",
                minWidth: "-moz-available",
                borderRadius: 8,
            },
            ".rbc-header": {
                padding: "10px 3px",
            },
            html: {
                scrollBehavior: 'smooth',
            },
        },            
            adContainer: {
            margin: "25px auto",
            padding: "18px 15px",
            background: "#FFF9F5",
            borderRadius: 10,
            textAlign: "center",
            border: "1px solid #F0E6DF",
            boxShadow: "0 3px 6px rgba(139, 86, 27, 0.08)",
            [theme.breakpoints.down("sm")]: {
                padding: "15px 10px",
                margin: "20px auto",
            },
            },
            topAd: {
            borderTop: "4px solid #890608",
            background: "#FFF5F5",
            marginTop: 0,
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
                marginTop: 10,
            },
            },
            midAd: {
            borderLeft: "4px solid #EA7606",
            background: "#FFF8F0",
            margin: "30px auto",
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
            },
            },
            bottomAd: {
            borderBottom: "4px solid #B5551B",
            background: "#FFF6F0",
            marginTop: 40,
            marginBottom: 30,
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
            },
            },
            postCommentsAd: {
            borderTop: "4px solid #B5551B",
            borderBottom: "4px solid #B5551B",
            background: "#FFF6F0",
            margin: "40px 0",
            [theme.breakpoints.down("sm")]: {
                borderWidth: 3,
            },
            
        },
    })
);

interface RankData {
    rank: number | null;  // Can be number or null
    total: number;
    city: string;
  }

interface DayHours {
    open1: string;  // Morning opening time
    close1: string; // Morning closing time
    open2: string;  // Evening opening time
    close2: string; // Evening closing time
    isClosed: boolean; // Whether the business is closed
    hasSecondTimeSlot: boolean;
}
type OpeningHours = {
    Sunday: DayHours;
    Monday: DayHours;
    Tuesday: DayHours;
    Wednesday: DayHours;
    Thursday: DayHours;
    Friday: DayHours; 
    Saturday: DayHours;
};

/*interface Announce {
    rules: string;
    trs_openingHours?: OpeningHours; // Opening hours data
}*/


const slugify = (input: unknown): string => {
    // Handle all possible falsy values and non-string inputs
    if (!input) return '';
    
    // Convert to string safely and handle non-string inputs
    const str = typeof input === 'string' ? input : String(input);
    
    try {
        return str
        // Convert accented characters to their ASCII equivalents
        .normalize('NFD') // Normalize to decomposed form
        .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
        
        // Handle specific accented characters (redundant but explicit)
        .replace(/[éèêë]/g, 'e')
        .replace(/[ÉÈÊË]/g, 'E')
        .replace(/[àâä]/g, 'a')
        .replace(/[ÀÂÄ]/g, 'A')
        .replace(/[îï]/g, 'i')
        .replace(/[ÎÏ]/g, 'I')
        .replace(/[ôö]/g, 'o')
        .replace(/[ÔÖ]/g, 'O')
        .replace(/[ùûü]/g, 'u')
        .replace(/[ÙÛÜ]/g, 'U')
        .replace(/ç/g, 'c')
        .replace(/Ç/g, 'C')
        
        // Convert to lowercase
        .toLowerCase()
        
        // Replace special characters
        .replace(/['"]/g, '') // Remove quotes completely
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/[^\w-]+/g, '') // Remove non-word chars except hyphens
        
        // Clean up hyphens
        .replace(/--+/g, '-') // Replace multiple hyphens with single
        .replace(/^-+/, '') // Trim hyphens from start
        .replace(/-+$/, ''); // Trim hyphens from end
    } catch (error) {
        console.error('Slugify processing error:', error);
        return '';
    }
    };


 // Slugify helpers (same as your previous function)
    const safeSlugify = (input: unknown, fallback: string = ''): string => {
    try {
        if (input === undefined || input === null || input === '') return fallback;
        return slugify(input) || fallback;
    } catch (error) {
        console.error('SafeSlugify error:', error);
        return fallback;
    }
    };

const countryService = new CountryService();
const announceService = new AnnouncesService();
//const registerService = new RegisterService();

export default function DetailAnnounce(props: any) {
  const classes = useStyles();
  const { t, i18n } = useTranslation<'common'>();
  const params: { id: string } = useParams();
  const query = useQuery();
  const history = useHistory();
  //const Location = useLocation();

  //const sessionHandler = React.useMemo(() => new SessionHandler(), []);
  const userContext = useContext(UserContext);
  const { user, setUser } = userContext;
  const currencyContext = useContext(CurrencyContext);
  const { currency } = currencyContext;

  const [loadingPage, setLoadingPage] = React.useState(true);
  const [, setLoading] = React.useState(false);
  const [announce, setAnnounce] = React.useState<any>({
     ...announceDefaultValue,
     visibleReviews: 0,
     note: "0", 
    });
  const [filteredReservation, setFilteredReservation] = React.useState([]);
  const [reviewList, setReviewList] = React.useState<IReview[]>([]);
  const [review, setReview] = React.useState<ReviewInputs>({ ...reviewInputDefaultValue });
  const [commissionFee, setCommissionFee] = React.useState<number>(0);
  const [pourcentage, setPourcentage] = React.useState<number>(0);
  const [comment, setComment] = React.useState<string>("");
  const [note, setNote] = React.useState<number | null>(0);
  const [isUpdating, setIsUpdating] = React.useState<boolean>(false);
  const [location, setLocation] = React.useState<ILocation>(locationDefaultValue);
  const [newGeoLocation, setNewGeoLocation] = React.useState<ILocation>(locationDefaultValue);
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [showComment, setShowComment] = React.useState<boolean>(false);
  const [showReservationCard, setShowReservationCard] = React.useState(false);
  const [showMap, setShowMap] = React.useState(false);
  const [showToogleButtons, setShowToogleButtons] = React.useState(true);
  const [jourProm, setJourProm] = React.useState<number>(1);
  const [priceConvertedProm, setPriceConvertedProm] = React.useState<number>(0);
  const [priceConverted, setPriceConverted] = React.useState<number>(0);
  const [priceWeeklyConverted, setPriceWeeklyConverted] = React.useState<number>(0);
  const [priceBiWeeklyConverted, setPriceBiWeeklyConverted] = React.useState<number>(0);
  const [priceMonthlyConverted, setPriceMonthlyConverted] = React.useState<number>(0);
  const [preReservation, setPreReservation] = React.useState({
    dci: query.get("dci") || "",
    dco: query.get("dco") || "",
    travellerAdultTotal: Number(query.get("travellerAdultTotal") ?? 2),
    travellerChildTotal: Number(query.get("travellerChildTotal")),
  });
  const [hotelAnnounces, setHotelAnnounces] = React.useState<IAnnounce[]>([]);
  const [jour, setJour] = React.useState<number>(1);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openDialogDisponible, setOpenDialogDisponible] = React.useState(false);
  const [indisponible, setIndisponible] = React.useState<any>(null);
  const [disponible, setDisponible] = React.useState<any>(null);
  const [loadingChangeFavorite, setLoadingChangeFavorite] = React.useState<boolean>(false);
  const [criteria, setCriteria] = React.useState<string[]>([]);
  const [visibleReviews, setVisibleReviews] = React.useState<IReview[]>([]);
  const [averageRating, setAverageRating] = React.useState<string>("0");
  const [reviewUpdateKey, setReviewUpdateKey] = React.useState(0);

  const [boundaries, setBoundaries] = React.useState({
    East: 0,
    West: 0,
    North: 0,
    South: 0,
    Center: {
      lng: 19.13697660832946,
      lat: -1.2138498098141102,
    },
    Zoom: 2,
  });
  const [viewCount, setViewCount] = React.useState<number>(0);
  const [isStickyVisible, setIsStickyVisible] = React.useState(false); // State to control sticky bar visibility
  //const [shouldRedirect, setShouldRedirect] = React.useState(false);


  const [surname, setSurname] = React.useState<string>("");
  const [lastName, setLastName] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [phoneNumber, setPhoneNumber] = React.useState<string>("");
  const [experienceDate, setExperienceDate] = React.useState<string>("");
  const [commentTitle, setCommentTitle] = React.useState<string>("");
  const [pictures, setPictures] = React.useState<File[]>([]);
  const MAX_PICTURES = 3;
  const [isCertified, setIsCertified] = React.useState<boolean>(false);
  const [loginDialogOpen, setLoginDialogOpen] = React.useState(false);
 const [openRegister, setOpenRegister] = React.useState(false);
  const [reviewFormState, setReviewFormState] = React.useState({
    note: 0, // Overall rating
    comment: "", // Review text
    commentTitle: "", // Review title
    experienceDate: "", // Date of experience
    isCertified: false, // Certification checkbox
    cleanliness: 0, // Secondary rating for cleanliness
    accuracy: 0, // Secondary rating for accuracy
    communication: 0, // Secondary rating for communication
    location: 0, // Secondary rating for location
    checkin: 0, // Secondary rating for check-in
    value: 0, // Secondary rating for value
    vehiclecondition: 0, // Secondary rating for vehicle condition (if applicable)
    customerservice: 0, // Secondary rating for customer service (if applicable)
    easeofbookingandpickup: 0, // Secondary rating for ease of booking (if applicable)
    valueformoney: 0, // Secondary rating for value for money (if applicable)
    surname: "", // Surname (if applicable)
    lastName: "", // Last name (if applicable)
    email: "", // Email (if applicable)
    phoneNumber: "", // Phone number (if applicable)
    pictures: [], // Array of uploaded pictures (if applicable)
});
const [userId, setUserId] = React.useState<string | null>(null);
const [showForm, setShowForm] = React.useState(false);
const [rankData, setRankData] = React.useState<RankData>({
  rank: null,   // Initial null value
  total: 0,
  city: ''
});
const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 6, // Default items per page
    totalCount: reviewList?.length || 0
  });

  // Add this early in your component
  //const pathSegments = window.location.pathname.split('/');
  //const isTRSPage = pathSegments[1] === 'exp_';

 // Slug-related useMemo hooks must be at the top level
  const propertyTypeSlug = React.useMemo(() => 
    safeSlugify(announce?.property?.type?.name || '', 'service'), 
    [announce?.property?.type?.name]
    );

    const propertyNameSlug = React.useMemo(() => 
    safeSlugify(announce?.property?.name || '', 'annonce'), 
    [announce?.property?.name]
    );

    const citySlug = React.useMemo(() => 
    safeSlugify(
        announce?.property?.address?.city?.nomFR || 
        announce?.property?.address?.city || 
        '', 
        'ville'
    ), 
    [announce?.property?.address?.city]
    );

    const regionSlug = React.useMemo(() => 
    safeSlugify(announce?.property?.address?.state || '', 'region'), 
    [announce?.property?.address?.state]
    );

  const searchType = announce?.property?.type?.searchType?.name ?? "";

  // Canonical URL calculation
  const canonicalUrl = React.useMemo(() => {
    const baseUrl =
        searchType === 'trs'
        ? `https://afriqpnb.com/exp_${propertyTypeSlug}/${propertyNameSlug}/${citySlug}/${regionSlug}/${announce._id}`
        : `https://afriqpnb.com/details-announce-${announce._id}`;
    return baseUrl; // No query parameters included
    }, [
        searchType,
        propertyTypeSlug,
        propertyNameSlug,
        citySlug,
        regionSlug,
        announce._id,
    ]);


    React.useEffect(() => {
        //console.log('Current announce:', announce);
        //console.log('Current path:', location?.pathname);

        if (!announce?._id || !announce?.property) return;

        // More defensive pathname check
        const currentPath = location?.pathname || '';
        const isDetailsPage = currentPath.includes('/details-announce');
        
        // More defensive type check
        const isTRS = announce?.property?.type?.searchType?.name === 'trs';

        if (isTRS && isDetailsPage) {
            // Add fallbacks for each slug generation
            const ptSlug = safeSlugify(announce.property.type?.name || '', 'service');
            const pnSlug = safeSlugify(announce.property.name || '', 'annonce');
            
            // More defensive city name check
            const cityName = announce.property.address?.city?.nomFR || 
                            announce.property.address?.city || 
                            '';
            const cSlug = safeSlugify(cityName, 'ville');
            
            // More defensive region check
            const region = announce.property.address?.state || '';
            const rSlug = safeSlugify(region, 'region');
            
            const newUrl = `/exp_${ptSlug}/${pnSlug}/${cSlug}/${rSlug}/${announce._id}`;
            
            // Only navigate if the URL would change
            if (newUrl !== currentPath) {
                history.replace(newUrl);
            }
        }
    }, [announce, location?.pathname, history, safeSlugify]);


    const toggleFormVisibility = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault(); // Prevents default action
        setShowForm(!showForm); // Ensure the form is shown

        // Scroll smoothly to the comment section
        setTimeout(() => {
            const commentSection = document.getElementById("comment-form");
            if (commentSection) {
                commentSection.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }, 100); // Small delay ensures the form is visible before scrolling
        const resetReview: any = {
            note: 0,
            visibleAuthor: "",
            visibleDate: undefined,
            experienceDate: undefined,
            isCertified: false,
            pictures: [],
        };
        setReview(resetReview);
    };

  

  const useFormattedDuration = () => {
    const { t } = useTranslation<'common'>(); // ✅ Hook is now inside a valid custom hook

    return (values: DurationValues) => {
        const { trs_duration_days, trs_duration_hours, trs_duration_minutes } = values;

        const parts: string[] = [];
        if (trs_duration_days > 0) parts.push(`${trs_duration_days} ${t('propriete.units.day', { count: trs_duration_days })}`);
        if (trs_duration_hours > 0) parts.push(`${trs_duration_hours} ${t('propriete.units.hour', { count: trs_duration_hours })}`);
        if (trs_duration_minutes > 0) parts.push(`${trs_duration_minutes} ${t('propriete.units.minute', { count: trs_duration_minutes })}`);

        return parts.length ? parts.join(", ") : t('propriete.labels.no_duration_specified');
    };
};

const formatDuration = useFormattedDuration();

  const onAddToFavorite = (itemId: string) => {
    setLoadingChangeFavorite(true);
    Annouce.AddToFav(user._id, itemId)
      .then(() => {
        setUser({ ...user, favorites: [...user.favorites, itemId] });
        setLoadingChangeFavorite(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingChangeFavorite(false); // Ensure loading state is updated
      });
  };

  const onRemoveToFavorite = (itemId: string) => {
    setLoadingChangeFavorite(true);
    Annouce.RemFromFav(user._id, itemId)
      .then(() => {
        setUser({
          ...user,
          favorites: user.favorites.filter((rm) => rm !== itemId),
        });
        setLoadingChangeFavorite(false);
      })
      .catch((err: any) => {
        console.log(err);
        setLoadingChangeFavorite(false); // Ensure loading state is updated
      });
  };

 /* const handleOnChangeNation = (val: any) => {
    setCodePhone(val.dial_code);
    setLogoPays(val.code);
}; */

// Add this helper function to calculate average rating
    const updateVisibleReviewsAndRating = (reviews: IReview[]) => {
        if (!reviews || reviews.length === 0) {
            const fallback = { averageRating: "0", visibleReviews: [] };
            setVisibleReviews(fallback.visibleReviews);
            setAverageRating(fallback.averageRating);
            return fallback;
        }

        const visibleReviews = reviews.filter(review => review?.isVisible);
        const totalNote = visibleReviews.reduce((acc: number, review: IReview) => acc + (review?.note || 0), 0);
        const averageRating = visibleReviews.length > 0 ? (totalNote / visibleReviews.length).toFixed(1) : "0";
        
        setVisibleReviews(visibleReviews);
        setAverageRating(averageRating);

        const result = { averageRating, visibleReviews };
        
        setAnnounce((prevAnnounce: any) => ({
        ...prevAnnounce,
        note: averageRating,
        visibleReviews: visibleReviews.length
        }));
        
        return result; // Now you can destructure this
    };

    // In your DetailAnnounce component (where the page content is loaded)
    React.useEffect(() => {
    if (!loadingPage && announce?._id) {
        // Check if fbq exists before calling it
        if (typeof window.fbq === 'function') {
        window.fbq('track', 'ViewContent', {
            content_ids: [announce._id],
            content_name: announce.property.name,
            content_type: announce.property.type.name,
            content_category: announce.property.type.searchType.name,
            currency: announce.devise || 'XAF',
            value: announce.price,
        });
        } else {
        console.warn('Facebook Pixel not available');
        // Optionally implement fallback tracking
        }
    }
    }, [loadingPage, announce]);


    React.useEffect(() => {
        //console.log("Review List in useEffect before updating visible reviews and rating:", reviewList);
        updateVisibleReviewsAndRating(reviewList);
    }, [reviewList]);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

   
  React.useEffect(() => {
    const fetchAnnounceData = async () => {
        try {
            setLoadingPage(true);
            
            // Fetch the announcement details
            const resAnnounce = await announceService.getAnnounceById(params.id);
            if (!resAnnounce.success) {
                setLoadingPage(false);
                return;
            }

            const announce = resAnnounce.data;
            
            // First update with basic announce data
            setAnnounce(announce);
            setViewCount(announce.views || 0);

            // Filter reservations
            setFilteredReservation(
                announce.reservation?.filter(
                    (reservation: any) =>
                        reservation.status[reservation.status.length - 1].status !== EStatus.REJECTED &&
                        reservation.status[reservation.status.length - 1].status !== EStatus.CANCELLED &&
                        reservation.status[reservation.status.length - 1].status !== EStatus.CANCELLED_BY_ADMIN
                ) || []
            );

            // Calculate ratings and reviews
            const { averageRating, visibleReviews } = updateVisibleReviewsAndRating(announce.reviews || []);
            
            // Final state update with all data
            setAnnounce((prev: any) => ({
                ...prev,
                note: averageRating,
                visibleReviews: visibleReviews.length
            }));
            

            if (announce.property?.type?.name === 'Restaurant' && announce.state === 'Published') {
                //console.log('Starting rank fetch...');
                
                const rankResponse = await announceService.getRestaurantRank(params.id);
                //console.log('Rank service response:', rankResponse);
              
                if (rankResponse.success && rankResponse.data) {
                    setRankData({
                      rank: rankResponse.data.rank,  // Now this will accept numbers
                      total: rankResponse.data.total,
                      city: rankResponse.data.city
                    });
                } else {
                  console.error('Failed to load rank:', rankResponse.error);
                  setRankData({
                    rank: null,
                    total: 0,
                    city: ''
                  });
                }
              }
            
            setLoadingPage(false);
            
        } catch (error) {
            console.error('Error fetching announce data:', error);
            setLoadingPage(false);
        }
    };

    fetchAnnounceData();

    // Increment view count
    announceService.incrementViewsById(params.id)
        .then((data) => {
            if (data.success) {
                setViewCount(prev => prev + 1);
            } else {
                console.error("Failed to increment view count:", data.message);
            }
        })
        .catch(console.error);
}, [params.id]);


  React.useEffect(() => {
    const handleScroll = () => {
        // Check if the scroll position is beyond a certain point
        if (window.scrollY > 100) { // Adjust the value as needed
            setIsStickyVisible(true);
        } else {
            setIsStickyVisible(false);
        }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
        window.removeEventListener('scroll', handleScroll);
    };
}, []);

  
  React.useEffect(() => {
    let pricePromotion;
    if (announce.promotion) {
      pricePromotion = announce.promotion.price + announce.promotion.price * (commissionFee / 100);
    }

    ConvertedDeviseWithMoneySign(announce.devise, currency, pricePromotion)
      .then((value: any) => setPriceConvertedProm(value))
      .catch((error) => console.log(error));
  }, [currency, jour, query, commissionFee]);

 
  const hotelId = announce.property.hotel?._id

   // Fetch announces from the same hotel if searchType is 'htls'
React.useEffect(() => {
    //console.log("Fetching hotel announces for hotel ID:", announce.property.hotel?._id);
    
    if (announce.property.type.searchType.name === 'htls' && announce.property.hotel) {
        announceService.GetAnnouncesByHotel(announce.property.hotel._id)
            .then((data) => {
                //console.log("Fetched hotel announces:", data);
                setHotelAnnounces(data);
            })
            .catch((error) => console.error('Error fetching hotel announces:', error));
    }
}, [announce]);
 
React.useEffect(() => {
    let calculatedJours = 1;
    let calculatedNbjoursProm = 0;

    const dci = query.get("dci");
    const dco = query.get("dco");
    
    if (dci && dco) {
        const msDay = 60 * 60 * 24 * 1000;
        const checkInDate: any = new Date(dci);
        const checkOutDate: any = new Date(dco);
        calculatedJours = Math.floor((checkOutDate - checkInDate) / msDay);
    }

    if (announce.promotion) {
        calculatedNbjoursProm = getDayNumberProm(
            preReservation.dci,
            preReservation.dco,
            announce.promotion.startDate,
            announce.promotion.endDate,
            announce.price,
            announce.promotion.price
        ).DateProm;
    }

    setJour(calculatedJours);
    setJourProm(calculatedNbjoursProm);

}, [query.get("dci"), query.get("dco"), announce.promotion, preReservation.dci, preReservation.dco, announce.price]);


  React.useEffect(() => {
    if (searchType === "apts" || searchType === "htls") {
        setCriteria([
            "Overall Experience",
            "Cleanliness",
            "Accuracy",
            "Communication",
            "Location",
            "Check-in",
            "Value",
        ]);
    } else if (searchType === "cars") {
        setCriteria([
            "Overall Experience",
            "Vehicle Condition",
            "Customer Service",
            "Ease of Booking and Pickup",
            "Value for Money",
        ]);
    } else {
        setCriteria([]);
    }
}, [searchType]);

/*
React.useEffect(() => {
    if (user?._id !== "") {
      announceService
        .checkUserBooking(user._id, announce._id || params.id || "")
        .then((response) => {
          // Check if there is at least one booking without an associated comment
          const canComment = response.data.some(
            (booking: any) => !booking.hasComment // Only bookings without comments
          );
          setShowComment(canComment); // Update state based on this condition
        })
        .catch((error) => setLoadingPage(false));
    }
  }, [user?._id, announce._id, params.id]);

  */

  React.useEffect(() => {
    if (searchType === "trs") {
      // Always allow commenting for "trs" searchType, regardless of user or booking status
      setShowComment(true);
    } else if (user?._id !== "") {
      // Original logic for other searchTypes
      announceService
        .checkUserBooking(user._id, announce._id || params.id || "")
        .then((response) => {
          const canComment = response.data.some(
            (booking: any) => !booking.hasComment
          );
          setShowComment(canComment);
        })
        .catch((error) => setLoadingPage(false));
    }
  }, [user?._id, announce._id, params.id, searchType]); // Add searchType as a dependency


  // Updated useEffect for fetching reviews
  React.useEffect(() => {
    const canManageReviews =
        user?.role?.name === ERoles.COUNTRY_ADMIN ||
        user?.role?.name === ERoles.ADMIN_SUPPORT ||
        user?.role?.name === ERoles.SUPER_ADMIN;

    const fetchReviews = async () => {
        try {
            

            // Single API call to fetch all reviews
            const allReviewsResponse = await announceService.fetchAllReviews(params.id);

            if (!allReviewsResponse.success) {
                console.error("Error fetching reviews:", allReviewsResponse.message);
                return;
            }

            // Determine which reviews to show based on permissions
            const visibleReviews = canManageReviews
                ? allReviewsResponse.reviews // Admins see all
                : allReviewsResponse.reviews.filter((review: IReview) => review.isVisible); // Others see only visible

            // Update state
            setReviewList(canManageReviews ? allReviewsResponse.reviews : visibleReviews);
            setVisibleReviews(visibleReviews);

            // Calculate average rating
            const totalNote = visibleReviews.reduce((acc: number, review: IReview) => acc + (review.note || 0), 0);
            const averageRating = visibleReviews.length > 0 ? (totalNote / visibleReviews.length).toFixed(1) : "0";

            setAverageRating(averageRating);
            setAnnounce((prevAnnounce: any) => ({
                ...prevAnnounce,
                note: averageRating,
                visibleReviews: visibleReviews.length,
            }));

        } catch (error) {
            console.error("Error fetching reviews:", error);
        }
    };

    fetchReviews();
}, [params.id, reviewUpdateKey]); // Keep same dependencies
  
  // Remove updateVisibleReviewsAndRating function and calls from your code
 

  const handleToggleCommentStatus = async (commentId: string, newStatus: "visible" | "hidden") => {
    try {
      // Convert 'visible'/'hidden' to boolean for the service method
      const statusBoolean = newStatus === "visible";
  
      // API call to update the review's visibility status on the server
      const response = await announceService.updateReviewVisibility(commentId, statusBoolean);
  
      if (response.success) {
        // Update the local state directly without triggering a re-fetch
        setReviewList((prevReviews) => {
          // Update the visibility of the specific review in the list
          const updatedReviews = prevReviews.map((review: IReview) =>
            review._id === commentId ? { ...review, isVisible: statusBoolean } : review
          );
  
          // Update visibleReviews based on the updated review list
          const updatedVisibleReviews = updatedReviews.filter((review) => review.isVisible);
          setVisibleReviews(updatedVisibleReviews);
  
          // Calculate and update the average rating
          const totalNote = updatedVisibleReviews.reduce((acc: number, review: IReview) => acc + (review.note || 0), 0);
          const newAverageRating = updatedVisibleReviews.length > 0 ? (totalNote / updatedVisibleReviews.length).toFixed(1) : "0";
          setAverageRating(newAverageRating);

          setAnnounce((prevAnnounce: any) => ({
            ...prevAnnounce,
            note: averageRating,
            visibleReviews: visibleReviews.length
          }));
  
          return updatedReviews; // Return the updated review list
        });
      } else {
        console.error("Failed to toggle comment status:", response.message);
      }
    } catch (error) {
      console.error("Error toggling comment status:", error);
    }
  };

  const handleClickOpenRegister = () => {
    setOpenRegister(true);
    setOpenDialog(false);
};
const handleCloseRegister = () => {
    setOpenRegister(false);
};
const handleClickOpenLoginDialog = () => { 
    setOpenRegister(false);
    setOpenDialog(true);
};


 /* const showErrorsMessages = () => {
    let allErrorMessages = "";
  
    errors.forEach((error) => {
      switch (error) {
        case "EMPTY NAME":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmptyLastnameOrFirstname);
          break;
        case "EMAIL USED":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmailUsed);
          break;
        case "EMAIL AND PASSWORD NULL":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.EmailOrPasswordNull);
          break;
        case "EMPTY COUNTRY":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.Emptypays);
          break;
        case "EMPTY PHONE":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.Emptyphone);
          break;
        case "CGU NOT ACCEPTED":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.CGUNOTACCEPTED);
          break;
        case "SMS VALIDATION CODE WRONG":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.SmsValidationCodeWrong);
          break;
        case "PASSWORD DIFFERENT":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.PasswordDifferent);
          break;
        case "PASSWORD WEAK":
          allErrorMessages += "," + getErrorLabel(UserErrorMessage.PasswordWeak);
          break;
        default:
          // 🚨 Catch any unknown error from backend and display it
          allErrorMessages += "," + error;
          break;
      }
    });
  
    // Remove the leading comma before setting the state
    setErrorMessages(allErrorMessages.substring(1));
  }; */
  

  const onChangeComment = (e: React.ChangeEvent<HTMLInputElement>) => {
    setComment(e.target.value);
    setReview({
      ...review,
      description: e.target.value,
      user: user,
      announce: announce,
    });
  };

  const onChangeCommentTitle = (e: React.ChangeEvent<HTMLInputElement>) => {    
    setCommentTitle(e.target.value);
    setReview({
      ...review,
      commentTitle: e.target.value,
      user: user,
      announce: announce,
    });
  };


  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files) return;

    const newFiles = Array.from(files);
    const remainingSlots = MAX_PICTURES - pictures.length;
    
    if (newFiles.length > remainingSlots) {
        alert(t('picture_upload.limit_alert', { 
            count: remainingSlots,
            max: MAX_PICTURES
        }));
        return;
    }

    if (pictures.length + newFiles.length > MAX_PICTURES) {
        alert(t('picture_upload.limit_reached', { max: MAX_PICTURES }));
        return;
    }

    setPictures(prev => [...prev, ...newFiles]);
    event.target.value = '';
};

const removePicture = (index: number) => {
    setPictures(prev => prev.filter((_, i) => i !== index));
};

 // Sync userId with userContext
 React.useEffect(() => {
    if (user?._id) {
        setUserId(user._id); // Update userId when user changes
    }
}, [user]);

// Callback function to handle login success
const handleLoginSuccess = (userId: string) => {
    setUserId(userId); // Set the user ID in the state
    setLoginDialogOpen(false); // Close the login dialog
};

// Function to open the login dialog




const handleSubmit = async (e: any): Promise<void> => {
    e.preventDefault();

    // Add basic debug log
    console.groupCollapsed("Review Submission Debug");
    //console.log("[1] Initiated submit handler");
  
    if (!userId) {
        //console.warn("[2] No user ID - saving state and opening login");
        setReviewFormState({
            note: note || 0,
            comment,
            commentTitle,
            experienceDate,
            isCertified,
            cleanliness: review.cleanliness || 0,
            accuracy: review.accuracy || 0,
            communication: review.communication || 0,
            location: review.location || 0,
            checkin: review.checkin || 0,
            value: review.value || 0,
            vehiclecondition: review.vehiclecondition || 0,
            customerservice: review.customerservice || 0,
            easeofbookingandpickup: review.easeofbookingandpickup || 0,
            valueformoney: review.valueformoney || 0,
            surname: surname || "",
            lastName: lastName || "",
            email: email || "",
            phoneNumber: phoneNumber || "",
            pictures: [] as any
        });
        setLoginDialogOpen(true);
        console.groupEnd();
        return;
    }

    setLoading(true);
    //console.log("[3] Loading state activated");

    /* Debug: Log current form state
    console.log("[4] Current Review State:", {
        note,
        comment,
        commentTitle,
        experienceDate,
        isCertified,
        review
    }); */

  
    let requiredFields: any[] = [];
  
    switch (searchType) {
        case "apts":
        case "htls":
            requiredFields = [
                review.note,
                review.cleanliness,
                review.accuracy,
                review.communication,
                review.location,
                review.checkin,
                review.value,
                review.description,
            ];
            break;
        case "cars":
            requiredFields = [
                review.note,
                review.vehiclecondition,
                review.customerservice,
                review.easeofbookingandpickup,
                review.valueformoney,
                review.description,
            ];
            break;
        case "trs":
            if (user?._id === "") {
                requiredFields = [
                    review.note,
                    review.description,
                    experienceDate,
                    isCertified,
                    surname,
                    lastName,
                    email,
                    phoneNumber,
                ];
            } else {
                requiredFields = [
                    review.note,
                    review.description,
                    experienceDate,
                    isCertified,
                ];
            }
            break;
        default:
            requiredFields = [];
    }
  
    const isAnyFieldEmpty = requiredFields.some(
        (field) => field === null || field === undefined || field.toString().trim() === ""
    );
  
    if (isAnyFieldEmpty) {
        console.error("[5] Validation Failed - Empty Fields:", requiredFields);
        alert(t("label.all-fields-must-be-completed"));
        setLoading(false);
        console.groupEnd();
        return;
    }
  
    try {
        const formData = new FormData();
        const reviewData = {
            ...review,
            description: comment,
            commentTitle,
            user: userId,
            announce: announce?._id ? announce._id : null,
            experienceDate: experienceDate ? new Date(experienceDate) : new Date(),
            isCertified: isCertified,
            visibleAuthor: review.visibleAuthor || (surname.trim() || lastName.trim() ? `${surname} ${lastName.charAt(0).toUpperCase()}` : ""),
            reviewDate: new Date()
        };

        // Debug: Log final payload before sending
        //console.log("[6] Constructed Review Data:", JSON.stringify(reviewData, null, 2));
        //console.log("[7] Files to upload:", pictures);

        formData.append('data', JSON.stringify(reviewData));

        // Debug: Verify FormData contents
        /*console.log("[8] FormData entries:");
        for (const [key, _value] of Array.from(formData.entries())) {
            //console.log(key, value);
          }*/
          
        if (pictures && pictures.length > 0) {
            pictures.forEach((file) => {
                formData.append('photos', file);
            });
        }

        let response;
        if (user.role.name === ERoles.SUPER_ADMIN ||
            user.role.name === ERoles.COUNTRY_ADMIN ||
            user.role.name === ERoles.ADMIN_SUPPORT) {
            
            response = await announceService.saveReviewWithFiles(formData);
            saveReviewAndRefresh(response);
        } else if (showComment) {
            if (searchType === "trs") {
                response = await announceService.saveReviewWithFiles(formData);
                saveReviewAndRefresh(response);
            } else {
                const bookingResponse = await announceService.checkUserBooking(user._id, announce._id || params.id || "");
                const availableBooking = bookingResponse.data.find((booking: any) => !booking.hasComment);
    
                if (!availableBooking) {
                    alert(t("label.noAvailableBookingForComment"));
                    setLoading(false);
                    return;
                }
    
                const updatedReviewData = {
                    ...reviewData,
                    reservation: availableBooking.reservationId
                };
                formData.set('data', JSON.stringify(updatedReviewData));

                // Add API call debugging
                //console.log("[9] Making API call to save review");
                
                response = await announceService.saveReviewWithFiles(formData);

                //console.log(`[10] API Response (${Math.round(performance.now() - apiStartTime)}ms):`, response);
                saveReviewAndRefresh(response);
            }
        }
    } catch (error) {
        console.error("Error saving review:", error);
        setLoading(false);
    }
};


  React.useEffect(() => {
    if (reviewFormState && userId) {
        // Restore the form state
        setNote(reviewFormState.note);
        setComment(reviewFormState.comment);
        setCommentTitle(reviewFormState.commentTitle);
        setExperienceDate(reviewFormState.experienceDate);
        setIsCertified(reviewFormState.isCertified);

        // Restore secondary ratings based on searchType
        if (searchType === "apts" || searchType === "htls") {
            setReview({
                ...review,
                cleanliness: reviewFormState.cleanliness,
                accuracy: reviewFormState.accuracy,
                communication: reviewFormState.communication,
                location: reviewFormState.location,
                checkin: reviewFormState.checkin,
                value: reviewFormState.value,
            });
        } else if (searchType === "cars") {
            setReview({
                ...review,
                vehiclecondition: reviewFormState.vehiclecondition,
                customerservice: reviewFormState.customerservice,
                easeofbookingandpickup: reviewFormState.easeofbookingandpickup,
                valueformoney: reviewFormState.valueformoney,
            });
        }

        /// Prepare the review data payload with the updated user object
        const reviewData = {
            ...reviewFormState,
            user: userId,
            announce: announce?._id ? announce._id : null,
            experienceDate: new Date(reviewFormState.experienceDate),
            isCertified: reviewFormState.isCertified,
            pictures: [], // Add base64 images if applicable
        };

        // Log the updated review data payload
        //console.log("Updated Review Data Payload:", reviewData);

        // Submit the review
        saveReviewAndRefresh(reviewData);
    }
}, [reviewFormState, user]);

    const handleLoginDialogClose = () => {
        setLoginDialogOpen(false);
        // Restore the review form state
        setNote(reviewFormState.note);
        setComment(reviewFormState.comment);
        setCommentTitle(reviewFormState.commentTitle);
        setExperienceDate(reviewFormState.experienceDate);
        // Restore other fields as needed
    };
    


  // Function to save review and refresh the comments section
  const saveReviewAndRefresh = (response: any) => {
    //console.log("Review Data:", response); // Log the payload
    setLoading(false);    

         
     // Update the reviews list
     setReviewList(prevReviews => [response.review, ...prevReviews]);
     
     // Update the average rating
     updateVisibleReviewsAndRating([response.review, ...reviewList]);

    // Reset all the input fields after submission
        setComment("");
        setCommentTitle("");
        setNote(0);
        setExperienceDate("");
        setIsCertified(false);
        setPictures([]);

    // Reset all rating fields based on searchType and propertyType
    const resetReview: any = {
        note: 0, // Reset Overall Experience rating
        visibleAuthor: "",
        visibleDate: undefined, // Reset visibleDate after submit
        experienceDate: undefined, // Reset experience date
        isCertified: false,       // Reset certification flag
        pictures: [],             // Reset pictures array
    };

    // Reset rating fields based on searchType
    if (searchType === "apts" || searchType === "htls") {
        resetReview.cleanliness = 0;
        resetReview.accuracy = 0;
        resetReview.communication = 0;
        resetReview.location = 0;
        resetReview.checkin = 0;
        resetReview.value = 0;
    } else if (searchType === "cars") {
        resetReview.vehiclecondition = 0;
        resetReview.customerservice = 0;
        resetReview.easeofbookingandpickup = 0;
        resetReview.valueformoney = 0;
    } else if (searchType === "trs") {
        const propertyType = announce?.property?.type?.name || "default";
        switch (propertyType) {
            case "restaurant":
                resetReview.foodquality = 0;
                resetReview.servicequality = 0;
                resetReview.ambiance = 0;
                resetReview.cleanliness = 0;
                resetReview.valueformoney = 0;
                break;
            case "nightlife":
                resetReview.entertainmentactivities = 0;
                resetReview.drinkquality = 0;
                resetReview.ambiance = 0;
                resetReview.servicequality = 0;
                resetReview.valueformoney = 0;
                break;
            case "spa":
                resetReview.servicequality = 0;
                resetReview.cleanliness = 0;
                resetReview.comfort = 0;
                resetReview.ambiance = 0;
                resetReview.valueformoney = 0;
                break;
            case "attraction":
                resetReview.entertainmentactivities = 0;
                resetReview.servicequality = 0;
                resetReview.cleanliness = 0;
                resetReview.valueformoney = 0;
                resetReview.location = 0;
                break;
            case "site historique":
                resetReview.historicalsignificance = 0;
                resetReview.cleanliness = 0;
                resetReview.servicequality = 0;
                resetReview.valueformoney = 0;
                resetReview.location = 0;
                break;
            case "musée":
                resetReview.exhibitsquality = 0;
                resetReview.cleanliness = 0;
                resetReview.servicequality = 0;
                resetReview.valueformoney = 0;
                resetReview.location = 0;
                break;
            default:
                // Fallback for undefined or unknown property types
                resetReview.servicequality = 0;
                resetReview.cleanliness = 0;
                resetReview.valueformoney = 0;
                resetReview.location = 0;
                break;
        }
    }

    // Update the review state with reset values
    setReview(resetReview);

     // Close the form after successful submission
     setShowForm(false);
          
};


  React.useEffect(() => {
    updateVisibleReviewsAndRating(reviewList);
    setAnnounce((prevAnnounce: any) => ({
      ...prevAnnounce,
      note: averageRating,
      visibleReviews: visibleReviews.length
    }));
  }, [reviewList]);

  // Update total count when reviews change
  React.useEffect(() => {
    setPagination(prev => ({
      ...prev,
      totalCount: reviewList?.length || 0
    }));
  }, [reviewList]);

  /* Create cache refs at the component level (outside useEffect)
    const specialFeeCache = useRef<Record<string, { percentage: number; timestamp: number }>>({});
    const commissionFeeCache = useRef<Record<string, { percentage: number; timestamp: number }>>({});
    const COMMISSION_CACHE_EXPIRY = 30 * 60 * 1000; // 30 minutes cache */
    
React.useEffect(() => {
    if (
        !announce?.property?.type?.name || // Missing property type
        !announce?.property?.address?.country?._id || // Missing country ID
        !announce?.property?.address?.city?._id // Missing city ID
    ) {
        return;
    }
    
    let percentage = 0;
    
    // Log announce data and start of useEffect for context
    //console.log("Starting useEffect with announce data:", announce);
  
    if (announce.property?.type.name === "Hôtel") {
      countryService
        .getSpecialFeeByPropertyType(announce.property?.type.name) 
        .then((response) => {
          if (response.success) {
           //console.log("Special Fee response:", response.data);
            percentage = response.data ? response.data.percentageTraveller : 0;
            setCommissionFee(percentage);
            setPourcentage(percentage);
            const normalPrice = (announce.price + announce.price * (percentage / 100)).toFixed(2);
            const normalWeeklyPrice = announce.priceWeekly ? (announce.priceWeekly + announce.priceWeekly * (percentage / 100)) / 7 : 0;
            const normalBiWeeklyPrice = announce.priceBiWeekly ? (announce.priceBiWeekly + announce.priceBiWeekly * (percentage / 100)) / 14 : 0;
            const normalMonthlyPrice = announce.priceMonthly ? (announce.priceMonthly + announce.priceMonthly * (percentage / 100)) / 30 : 0;
            
            ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, normalPrice)
              .then((value: any) => setPriceConverted(value))
              .catch((error) => console.log("Error converting normal price:", error));
  
            ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalWeeklyPrice))
              .then((value: any) => setPriceWeeklyConverted(value))
              .catch((error) => console.log("Error converting weekly price:", error));
  
            ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalBiWeeklyPrice))
              .then((value: any) => setPriceBiWeeklyConverted(value))
              .catch((error) => console.log("Error converting biweekly price:", error));
  
            ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalMonthlyPrice))
              .then((value: any) => setPriceMonthlyConverted(value))
              .catch((error) => console.log("Error converting monthly price:", error));
          } else {
            //console.log("Failed to get special fee by property type:", response);
          }
        });
    } else {
      //console.log("country.name:", announce.property?.address?.country?.name);
      //console.log("city.name:", announce.property?.address?.city?.name);
  
        countryService
    .getCommissionFeeByCountryIdAndCityId(
        announce.property?.address?.country?._id,
        announce.property?.address?.city?._id
    )
    .then((respCom) => {
        //console.log("CommissionFeeByCountryIdAndCityId from DetailAnnounce");
        let percentage = 0; // Default commission fee

        if (respCom.success && respCom.data && respCom.data.percentage) {
        percentage = respCom.data.percentage; // Use API value if available
        } else {
        //console.warn("No commission fee found. Applying default commission fee of 0.");
        }

        setCommissionFee(percentage);

        const normalPrice = (announce.price + announce.price * (percentage / 100)).toFixed(2);
        const normalWeeklyPrice = announce.priceWeekly
        ? (announce.priceWeekly + announce.priceWeekly * (percentage / 100)) / 7
        : 0;
        const normalBiWeeklyPrice = announce.priceBiWeekly
        ? (announce.priceBiWeekly + announce.priceBiWeekly * (percentage / 100)) / 14
        : 0;
        const normalMonthlyPrice = announce.priceMonthly
        ? (announce.priceMonthly + announce.priceMonthly * (percentage / 100)) / 30
        : 0;

        // Convert and update prices
        ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, normalPrice)
        .then((value: any) => setPriceConverted(value))
        .catch((error) => console.log("Error converting normal price:", error));

        ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalWeeklyPrice))
        .then((value: any) => setPriceWeeklyConverted(value))
        .catch((error) => console.log("Error converting weekly price:", error));

        ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalBiWeeklyPrice))
        .then((value: any) => setPriceBiWeeklyConverted(value))
        .catch((error) => console.log("Error converting biweekly price:", error));

        ConvertedDeviseWithMoneySign(announce.devise || "EUR", currency, Number(normalMonthlyPrice))
        .then((value: any) => setPriceMonthlyConverted(value))
        .catch((error) => console.log("Error converting monthly price:", error));
    })
    .catch((error) => {
        console.error("Error fetching commission fee by country and city. Applying default fee of 0.", error);
        setCommissionFee(0); // Fallback to default commission fee in case of error
    });

    }
  }, [announce?.property?.type?.name, // Dependency 1: Property type
    announce?.property?.address?.country?._id, // Dependency 2: Country ID
    announce?.property?.address?.city?._id, // Dependency 3: City ID
    currency, // Dependency 4: Currency (for price conversions)
  ]);
  

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    setPagination(prev => ({ ...prev, page }));
    
    // Small delay to ensure state updates & re-render
    setTimeout(() => {
      document.getElementById('comment-section')?.scrollIntoView({ behavior: 'smooth' });
    }, 150); // Adjust delay if needed (100ms is usually safe)
  };

  const commentSection = () => {    
  
    if (reviewList && reviewList.length > 0) {
        // Sort reviews by visibleDate (newest first) or createdAt if visibleDate doesn't exist
        const sortedReviews = [...reviewList].sort((a, b) => {
          const dateA = a.visibleDate ? new Date(a.visibleDate).getTime() : new Date(a.reviewDate).getTime();
          const dateB = b.visibleDate ? new Date(b.visibleDate).getTime() : new Date(b.reviewDate).getTime();
          return dateB - dateA; // Newest first
        });
    
        const startIndex = (pagination.page - 1) * pagination.pageSize;
        const paginatedReviews = sortedReviews.slice(startIndex, startIndex + pagination.pageSize);
      return (
        <>
          <Grid container spacing={4}>
            {paginatedReviews.map((review, index) => (
              <Grid item xs={12} md={6} key={index}>
                <React.Suspense fallback={<CircularProgress />}>
                    <CommentCard
                    user={user}
                    review={review}
                    onToggleStatus={(newStatus: 'visible' | 'hidden') => {
                        if (review._id) {
                        return handleToggleCommentStatus(review._id, newStatus);
                        }
                        return Promise.resolve();
                    }}
                    canManage={
                        user?.role?.name === ERoles.COUNTRY_ADMIN ||
                        user?.role?.name === ERoles.ADMIN_SUPPORT ||
                        user?.role?.name === ERoles.SUPER_ADMIN
                    }
                    />
                </React.Suspense>
              </Grid>
            ))}
          </Grid>
  
          {reviewList.length > pagination.pageSize && (
            <Stack spacing={2} alignItems="center" sx={{ mt: 4 }}>
              <Pagination
                count={Math.ceil(pagination.totalCount / pagination.pageSize)}
                page={pagination.page}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#890608',
                    borderColor: '#890608',
                    '&:hover': {
                      backgroundColor: '#f5f5f5'
                    }
                  },
                  '& .Mui-selected': {
                    backgroundColor: '#890608',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#6a0506'
                    }
                  }
                }}
              />
              <Typography variant="caption" color="textSecondary">
                {t('pagination.showing')} {startIndex + 1}-{Math.min(startIndex + pagination.pageSize, pagination.totalCount)} {t('pagination.of')} {pagination.totalCount} {t('pagination.comments')}
              </Typography>
            </Stack>
          )}
        </>
      );
    }
  
    return null;
  };
  

  const changeLocationHandler = () => {
    setIsUpdating(true);
  };

  const cancelUpdateHandler = () => {
    setIsUpdating(false);
  };

  const handleUpdate = () => {
    setNewGeoLocation(location);
    const property = {
      _id: announce.property._id,
      location: location,
    };
    announceService.updatePropertyById(property).then().catch((error) => console.log("error on updating geolocation", error));
    setIsUpdating(false);
  };

  const setNewLocation = (longitude: number, latitude: number) => {
    setLocation({ longitude, latitude });
  };

  let tab_photos: any = [];
  let tab_reservation: any = [];
  let res_occupe: any = [];
  let tab_stars: any = [];
  let tab_type: any = [];

    if (announce && announce.property && announce.property.equipments) {
    announce.property.equipments.forEach((equipement: any) => {
        if (equipement?.category?.name) {
        const categoryName = i18n.language === "fr" 
            ? equipement.category.name.fr 
            : equipement.category.name.en;

            //console.log('Category Name:', categoryName);


        const existingCategory = tab_type.find(
            (item: any) => item.category === categoryName
        );

        if (existingCategory) {
            // If the category already exists, add the equipment to that category
            existingCategory.equipement.push(equipement);
        } else {
            // Otherwise, create a new category entry
            tab_type.push({
            category: categoryName,
            equipement: [equipement],
            });
        }
        }
    });
    }

  


  announce.property.photos.map((photo: any) => {
    tab_photos.push(photo);
  });

  const toogleReservationCard = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
      return;
    }
    setShowReservationCard(!showReservationCard);
  };

  const toogleMap = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (event.type === "keydown" && ((event as React.KeyboardEvent).key === "Tab" || (event as React.KeyboardEvent).key === "Shift")) {
      return;
    }
    setShowMap(!showMap);
  };

  (announce.promotion || announce.reservation) &&
    filteredReservation.map((date: any, indx: number) => {
      var date1 = new Date(moment(date.dateCheckIn).format("MM/DD/YYYY"));
      var date2 = new Date(moment(date.dateCheckOut).format("MM/DD/YYYY"));

      var time_diff = date2.getTime() - date1.getTime();
      var days_Diff = time_diff / (1000 * 3600 * 24);
      for (let i = 0; i < days_Diff; i++) {
        res_occupe.push(new Date(moment(new Date(date.dateCheckIn).setDate(new Date(date.dateCheckIn).getDate() + i)).format("YYYY/MM/DD")));
      }
      if (announce.property?.type.name !== "Hôtel")
        tab_reservation.push({
          id: indx,
          title: t("label.reserve-detail"),
          allDay: true,
          start: new Date(date.dateCheckIn),
          end: new Date(date.dateCheckOut),
        });
    });

  if (announce.property.hotel !== null) {
    for (let i: number = 0; i < announce.property.hotel.stars; i++) {
      tab_stars.push(i);
    }
  }

  tab_reservation.push({
    title: t("label.offres-exceptionnelles"),
    allDay: true,
    start: new Date(announce.promotion?.startDate),
    end: new Date(announce.promotion?.endDate),
  });
  if (announce?.dateIndisponible !== undefined) {
    announce?.dateIndisponible.forEach((element: any, indx: number) => {
      tab_reservation.push({
        title: t("label.reserve-detail"),
        allDay: true,
        start: new Date(element),
        end: new Date(element),
      });
    });
  }

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleCloseDisponible = () => {
    setOpenDialogDisponible(false);
  };

  const onSelecting = (range: { action: string; start: any }) => {
    const foundEvent = tab_reservation.find(
      (item: any, index: number) => (item.title === "Indisponible" || item.title === "Unavailable") && moment(item.start).isSame(moment(range.start))
    );
    if (!foundEvent) {
      let click = range.action === "click" || range.action === "select";
      setOpenDialog(click);
      setIndisponible(range.start);
    }
    return false;
  };

  const handleInDisponibilite = () => {
    if (indisponible !== undefined) {
      announceService
        .indisponible(announce._id, indisponible)
        .then((response) => {
          if (response.success) {
            setOpenDialog(false);
            setRefreshKey((oldKey) => oldKey + 1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const onSelectingAnEvent = (e: any) => {
    if (e.id === undefined) {
      setOpenDialogDisponible(true);
      setDisponible(e.start);
    }
  };

  const handleDisponibilite = () => {
    if (disponible !== undefined) {
      announceService
        .disponible(announce._id, disponible)
        .then((response) => {
          if (response.success) {
            setOpenDialogDisponible(false);
            setRefreshKey((oldKey) => oldKey + 1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };


  function extractYouTubeID(url: string): string | null {
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);
    const hostname = parsedUrl.hostname;
    const pathname = parsedUrl.pathname;

    // Handle youtu.be/<id>
    if (hostname === 'youtu.be') {
      return pathname.split('/')[1];
    }

    // Handle youtube.com/watch?v=<id>
    if (parsedUrl.searchParams.has('v')) {
      return parsedUrl.searchParams.get('v');
    }

    // Handle youtube.com/embed/<id>
    if (pathname.startsWith('/embed/')) {
      return pathname.split('/embed/')[1];
    }

    // Handle youtube.com/shorts/<id>
    if (pathname.startsWith('/shorts/')) {
      return pathname.split('/shorts/')[1];
    }

    // Handle youtube.com/<id> (e.g. https://youtube.com/1nNdYH8BKB8)
    const segments = pathname.split('/');
    if (segments.length === 2 && segments[1].length === 11) {
      return segments[1];
    }

    return null;
  } catch (error) {
    return null;
  }
}


  function isValidUrl(string: string): boolean {
    try {
      new URL(string);
      return true;
    } catch (_) {
      return false;
    }
  }

  const GoogleMapsEmbed = ({ url }: { url?: string }) => {
    return (
        <div 
            style={{ 
                overflow: "hidden", 
                paddingBottom: "56.25%", 
                position: "relative", 
                height: 0, 
                border: "2px solid #890608", 
                borderRadius: "8px" // Optional rounded corners
            }}
        >
            <iframe
                src={url}
                width="100%"
                height="100%"
                style={{ position: "absolute", top: 0, left: 0, border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Visite vidéo - ${description}`}
            />
        </div>
    );
    };

    
    const announceTitle =
        announce.property.type.name === "Appartement"
        ? t("announce.AppartementMeublé")
        : announce.property.type.name === "Chambre"
        ? t("announce.ChambreMeublée")
        : announce.property.type.name === "Maison"
        ? t("announce.VillaMeublée")
        : announce.property.type.name === "Hôtel"
        ? t("announce.EtablissementHotelier")
        : announce.property.type.name === "Suite"
        ? t("announce.SuiteMeublée")
        : announce.property.type.name;

    const descriptionStays = t("announce.descriptionStays", {
        announceTitle,
        rooms: announce.property.rooms,
        beds: announce.property.lit,
        bathrooms: announce.property.bathrooms,
        quartier: announce.property.address.quartier,
        city: announce.property.address.city?.name,
        name: announce.property.name,
        passengers: announce.property.maximumGuests,
    });

    const descriptionCars = t("announce.descriptionCars", {
        announceTitle,
        rooms: announce.property.rooms,
        beds: announce.property.vhcl_passengers,
        bathrooms: announce.property.vhcl_doors,
        quartier: announce.property.address.quartier,
        city: announce.property.address.city?.name,
        name: announce.property.name,
        passengers: announce.property.maximumGuests,
    });

    const descriptionEstate = t("announce.descriptionEstate", {
        announceTitle,
        rooms: announce.property.rooms,
        beds: announce.property.lit,
        bathrooms: announce.property.bathrooms,
        quartier: announce.property.address.quartier,
        city: announce.property.address.name,
        name: announce.property.name,
        passengers: announce.property.maximumGuests,
    });

    const descriptionCircuit = t("announce.descriptionCircuit", {
        announceTitle,
        rooms: announce.property.rooms,
        beds: announce.property.lit,
        bathrooms: announce.property.bathrooms,
        quartier: announce.property.address.quartier,
        city: announce.property.address.city?.name,
        name: announce.property.name,
        passengers: announce.property.maximumGuests,
    });

    


     const description = (() => {
        switch (searchType) {
        case "apts":
            return descriptionStays;
        case "htls":
            return descriptionStays;
        case "cars":
            return descriptionCars;
        case "rstt":
            return descriptionEstate;
        case "trs":
            return descriptionCircuit;
        default:
            //console.log("No valid searchType, Description is empty");
            return "";
        }
    })();

    const generateSchemaMarkup = (announce: IAnnounce) => {
        const { property } = announce;
        const searchType = property.type.searchType.name;
        const experienceType = property.type.name.toLowerCase();
    
        // Base schema object with common fields
        let schema: any = {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": property.name || "Unnamed Item",
            "description": description,
            "image": `https://afriqpnb.com/api/images/properties/${property.photos[0]?.filename}`,
            "url": window.location.href,
            "address": {
                "@type": "PostalAddress",
                "addressLocality": property.address.city?.nomFR,
                "addressCountry": property.address.country?.nomFR,
                "streetAddress": property.trs_address || property.address.quartier
            }
        };
    
        // Process rating and reviews data
        const validReviews = (visibleReviews || [])
            .filter(review => {
                const note = Number(review.note);
                return !isNaN(note) && note >= 1 && note <= 5;
            })
            .map(review => ({
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": Math.min(Math.max(Number(review.note), 1), 5)
                },
                "author": {
                    "@type": "Person",
                    "name": review.visibleAuthor || review.user?.firstName || "Anonymous"
                },
                "reviewBody": (review.description || "").trim(),
                "datePublished": new Date(review.visibleDate || review.reviewDate).toISOString(),
                /*"itemReviewed": {
                    "@type": schema["@type"],
                    "name": property.name || "Unnamed Item",
                    "@id": schema.url
                },*/
                ...(review.commentTitle ? { name: review.commentTitle } : {})
            }));
    
        // Add reviews if valid
        if (validReviews.length > 0) {
            schema.review = validReviews;
        }
    
        // Calculate aggregate rating
        const reviewCount = validReviews.length;
        const totalRating = validReviews.reduce((acc, review) => acc + review.reviewRating.ratingValue, 0);
        const ratingValue = reviewCount > 0 ? (totalRating / reviewCount).toFixed(1) : 0;
        const normalPrice = (announce.price + announce.price * (pourcentage / 100)).toFixed(2);
    
        // Add aggregate rating if applicable
        if (reviewCount > 0) {
            schema.aggregateRating = {
                "@type": "AggregateRating",
                "ratingValue": ratingValue,
                "reviewCount": reviewCount,
                "bestRating": 5,
                "worstRating": 1
            };
        }
    
        // Schema type configuration with required offers
        switch (searchType) {
            case 'apts': // Furnished Apartments
                schema["@type"] = "Product";
                schema.category = "Furnished Apartment";
                schema.numberOfRooms = property.rooms;
                schema.numberOfBeds = property.lit;
                schema.occupancy = property.maximumGuests;
                schema.offers = {
                    "@type": "Offer",
                    "priceCurrency": announce.devise,
                    "price": normalPrice,
                    "availability": "https://schema.org/InStock",
                    "priceValidUntil": new Date(new Date().getFullYear(), 11, 31).toISOString()
                };
                break;
    
            case 'htls': // Hotels
                schema["@type"] = "Hotel";
                schema.numberOfRooms = property.rooms;
                schema.occupancy = property.maximumGuests;
                schema.offers = {
                    "@type": "Offer",
                    "priceCurrency": announce.devise,
                    "price": normalPrice,
                    "availability": "https://schema.org/InStock",
                    "priceValidUntil": new Date(new Date().getFullYear(), 11, 31).toISOString()
                };
                if (property.equipments?.length) {
                    schema.amenityFeature = property.equipments.map((equipment: IEquipment) => ({
                        "@type": "LocationFeatureSpecification",
                        "name": equipment.name.fr,
                        "description": equipment.description?.fr || "",
                        ...(equipment.category && {
                            "additionalProperty": {
                                "@type": "PropertyValue",
                                "name": "Category",
                                "value": equipment.category.name.fr
                            }
                        })
                    }));
                }
                break;
    
            case 'cars': // Car Rentals
                schema["@type"] = "Product";
                schema.category = "Vehicle Rental";
                schema.additionalProperty = {
                    "@type": "PropertyValue",
                    name: "Vehicle Details",
                    value: `${property.vhcl_brand} ${property.vhcl_model} (${property.vhcl_year})`
                };
                schema.offers = {
                    "@type": "Offer",
                    "priceCurrency": announce.devise,
                    "price": normalPrice,
                    "availability": "https://schema.org/InStock",
                    "priceValidUntil": new Date(new Date().getFullYear(), 11, 31).toISOString()
                };
                break;
    
            case 'rstt': // Real Estate
                schema["@type"] = "Product";
                schema.category = "Real Estate";
                schema.offers = {
                    "@type": "Offer",
                    "priceCurrency": announce.devise,
                    "price": normalPrice,
                    "availability": "https://schema.org/InStock",
                    "priceValidUntil": new Date(new Date().getFullYear(), 11, 31).toISOString()
                };
                break;
    
            case 'trs': // Tours & Experiences
                schema["@type"] = "TouristAttraction";
                schema.touristType = "Adventure";
                schema.offers = {
                    "@type": "Offer",
                    "priceCurrency": announce.devise,
                    "price": normalPrice,
                    "availability": "https://schema.org/InStock",
                    "priceValidUntil": new Date(new Date().getFullYear(), 11, 31).toISOString()
                };
                switch (experienceType) {
                    case 'restaurant':
                        schema["@type"] = "Restaurant";
                        schema.servesCuisine = property.trs_typeDeCuisine?.split(', ');
                        schema.priceRange = property.trs_priceRange?.replace('€', '$') || "$$-$$$";
                        break;
                    case 'spa':
                        schema["@type"] = "HealthAndBeautyBusiness";
                        schema.description = announce.description;
                        break;
                    case 'museum':
                        schema["@type"] = "Museum";
                        schema.exhibit = {
                            "@type": "Exhibit",
                            "name": property.name,
                            "description": announce.description
                        };
                        break;
                    case 'historic site':
                        schema["@type"] = "LandmarksOrHistoricalBuildings";
                        schema.historicalSignificance = announce.description;
                        break;
                }
                break;
        }
    
        return schema;
    };

    const schemaMarkup = React.useMemo(() => {
    return generateSchemaMarkup(announce);
    }, [
        announce,
        description,
        visibleReviews,
        pourcentage,
        t 
    ]);



      

   const announceType =  
    announce.property.type.searchType.name === "apts"
        ? "logements-meubles"
        : announce.property.type.searchType.name === "htls"
        ? "hotels"
        : announce.property.type.searchType.name === "cars"
        ? "voitures"
        : announce.property.type.searchType.name === "rstt"
        ? "immobilier"
        : announce.property.type.searchType.name === "trs"
        ? "restaurants-activites"
        : announce.property.type.searchType.name === "evts"
        ? "evenements"
        : announce.property.type.name;

  const pageTitle =
    announce.property.type.searchType.name === "apts" || announce.property.type.searchType.name === "htls"
      ? `${announce.property.name} - ${announceTitle} · ${announce.property.address.quartier} · ${announce.property.address.city?.name} | AfriqPnB`
      : `${announce.property.name} - ${announceTitle} · ${announce.property.address.city?.name} | AfriqPnB`;

 

 

  const currentUrl = window.location.href;
  const ogImageUrl = `https://afriqpnb.com/api/images/properties/${announce.property.photos[0]?.filename}`;
  const ogImageAlt = t("ogImageAnnonceAlt");
  const keywords =
    "studio meublé douala 15000, Appartement meublé douala photos, appartement meublé douala bonamoussadi, appartement meublé douala bonapriso, studio meublé douala 10000, appartement meublé douala makepe, appartement meublé douala bonamoussadi contact, appartement meublé yaoundé, appartement meublé kribi prix, appartement meublé kribi moins cher, appartement meublé kribi 2 chambres, logement kribi pas cher, appartement meublé kribi avec piscine, appartement meublé kribi 3 chambres, maisons et appartements à louer à kribi, appartements meublés kribi bord de mer";

  const canComment =
    user.role.name === ERoles.SUPER_ADMIN || user.role.name === ERoles.COUNTRY_ADMIN || user.role.name === ERoles.ADMIN_SUPPORT || showComment;
    
    interface DurationValues {
        trs_duration_days: number;
        trs_duration_hours: number;
        trs_duration_minutes: number;
    }    

    const id = announce?._id;
    const slug = slugify(announce?.property?.name)
    const propertyType = slugify(announce?.property?.type.name)
    const city = slugify(announce.property?.address?.city?.nomFR);
    const region = slugify(announce?.property?.address?.state);

    const handleShare = () => {
        const shareData = {
          title: announceTitle || t('annonce.listing_title'),
          text: t('annonce.check_out_this_listing'),
          url: currentUrl,
        };
        
        if (navigator.share) {
          navigator.share(shareData).catch(err => {
            console.error('Error sharing:', err);
            navigator.clipboard.writeText(shareData.url);
            alert(t('annonce.link_copied'));
          });
        } else {
          navigator.clipboard.writeText(shareData.url);
          alert(t('annonce.link_copied'));
        }
      };


    const getTypographyContent = (searchType: any) => {
        // Determine the correct field for language
        const langSuffix = i18n.language === "fr" ? "nomFR" : "nomEN";
    
        const getCityName = () =>
            announce.property.address.city?.[langSuffix] || "Unknown City";
        const getCountryName = () =>
            announce.property.address.country?.[langSuffix] || "Unknown Country";
    
        switch (searchType) {
            case "apts":
                return (
                    <Typography>
                        {announce.property.address.quartier ? (
                            <a 
                                href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=${announce.property.address.quartier}&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                                style={{ textDecoration: 'underline', color: 'inherit' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {announce.property.address.quartier}
                            </a>
                            ) : (
                            <span>N/A</span>
                        )}
                        {", "}
                        <a 
                            href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                            style={{ textDecoration: 'underline', color: 'inherit' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {getCityName()}
                        </a>
                        {" | "}
                        <span>
                            {announce.property.maximumGuests === 1
                                ? `${announce.property.maximumGuests} ${t("announceGuest")} Maximum`
                                : `${announce.property.maximumGuests} ${t("announceGuests")} Maximum`}
                        </span>
                        {" | "}
                        {announce.property.rooms === 1
                            ? `${announce.property.rooms} ${t("announceRoom")}`
                            : `${announce.property.rooms} ${t("announceRooms")}`}
                        <span>
                            {" | "}
                            {announce.property.lit === 1
                                ? `${announce.property.lit} ${t("announceBed")}`
                                : `${announce.property.lit} ${t("announceBeds")}`}
                        </span>
                        {" | "}
                        <span>
                            {announce.property.bathrooms === 1
                                ? `${announce.property.bathrooms} ${t("announceBathroom")}`
                                : `${announce.property.bathrooms} ${t("announceBathrooms")}`}
                        </span>
                        {visibleReviews.length > 0 && (
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            overflow: 'hidden', // Ensures content doesn't overflow
                            whiteSpace: 'nowrap', // Prevents text from wrapping
                            textOverflow: 'ellipsis', // Adds ellipsis at the end
                            maxWidth: '100%', // Adjust this value as needed
                            marginTop: '8px'
                        }}>
                            {/* Render 5 balls for the note */}
                            {[...Array(5)].map((_, index) => {
                                const fillPercentage = Math.min(Math.max(announce.note - index, 0), 1) * 100;
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            border: '1px solid #890608',
                                            marginRight: '4px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${fillPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#890608',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                    </div>
                                );
                            })}
                            {/* Display the number of reviews */}
                            <a href="#comment-section" style={{ textDecoration: 'underline', color: 'inherit' }}>
                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                    {visibleReviews.length} {visibleReviews.length === 1 ? t("annonce.labels.review") : t("annonce.labels.reviews")}
                                </span>
                            </a>
                        </div>
                        )}
                    </Typography>
                );
            case "htls":
                return (
                    <Typography>
                        <div style={{ fontSize: 20, fontWeight: 'bold', color: '#890608', marginBottom: 5}}>
                        {announce.property?.hotel?.address?.zipcode || announce.property?.address?.zipcode || "-"}
                        </div>
                        {announce.property.address.quartier ? (
                            <a 
                                href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=${announce.property.address.quartier}&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                                style={{ textDecoration: 'underline', color: 'inherit' }}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {announce.property.address.quartier}
                            </a>
                            ) : (
                            <span>N/A</span>
                        )}
                        {", "}
                        <a 
                            href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                            style={{ textDecoration: 'underline', color: 'inherit' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {getCityName()}
                        </a>
                        {" | "}
                        <span>
                            {announce.property.maximumGuests === 1
                                ? `${announce.property.maximumGuests} ${t("announceGuest")} Maximum`
                                : `${announce.property.maximumGuests} ${t("announceGuests")} Maximum`}
                        </span>
                        {" | "}
                        {announce.property.rooms === 1
                            ? `${announce.property.rooms} ${t("announceRoom")}`
                            : `${announce.property.rooms} ${t("announceRooms")}`}
                        <span>
                            {" | "}
                            {announce.property.lit === 1
                                ? `${announce.property.lit} ${t("announceBed")}`
                                : `${announce.property.lit} ${t("announceBeds")}`}
                        </span>
                        {" | "}
                        <span>
                            {announce.property.bathrooms === 1
                                ? `${announce.property.bathrooms} ${t("announceBathroom")}`
                                : `${announce.property.bathrooms} ${t("announceBathrooms")}`}
                        </span>
                        {visibleReviews.length > 0 && (
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            overflow: 'hidden', // Ensures content doesn't overflow
                            whiteSpace: 'nowrap', // Prevents text from wrapping
                            textOverflow: 'ellipsis', // Adds ellipsis at the end
                            maxWidth: '100%', // Adjust this value as needed
                            marginTop: '8px'
                        }}>
                            {/* Render 5 balls for the note */}
                            {[...Array(5)].map((_, index) => {
                                const fillPercentage = Math.min(Math.max(announce.note - index, 0), 1) * 100;
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            border: '1px solid #890608',
                                            marginRight: '4px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${fillPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#890608',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                    </div>
                                );
                            })}
                            {/* Display the number of reviews */}
                            <a href="#comment-section" style={{ textDecoration: 'underline', color: 'inherit' }}>
                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                    {visibleReviews.length} {visibleReviews.length === 1 ? t("annonce.labels.review") : t("annonce.labels.reviews")}
                                </span>
                            </a>
                        </div>
                        )}
                    </Typography>
                );
            case "cars":
                return (
                    <Typography>
                        <a 
                            href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                            style={{ textDecoration: 'underline', color: 'inherit' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {getCityName()}
                        </a>
                        {" | "}
                        <span>{getCountryName()}</span>
                        {" | "}
                        <span>
                            {announce.property.vhcl_passengers === 1
                                ? `${announce.property.vhcl_passengers} ${t("label.passager")} Maximum`
                                : `${announce.property.vhcl_passengers} ${t("label.passagers")} Maximum`}
                        </span>
                        {" | "}
                        {announce.property.vhcl_bags === 1
                            ? `${announce.property.vhcl_bags} ${t("label.baggage")}`
                            : `${announce.property.vhcl_bags} ${t("label.baggages")}`}
                        <span>
                            {" | "}
                            {announce.property.vhcl_doors === 1
                                ? `${announce.property.vhcl_doors} ${t("label.porte")}`
                                : `${announce.property.vhcl_doors} ${t("label.portes")}`}
                        </span>
                        {" | "}
                        <span>
                            {announce.property.vhcl_fuelType
                                ? announce.property.vhcl_fuelType.charAt(0).toUpperCase() +
                                  announce.property.vhcl_fuelType.slice(1)
                                : ""}
                        </span>
                        {visibleReviews.length > 0 && (
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            overflow: 'hidden', // Ensures content doesn't overflow
                            whiteSpace: 'nowrap', // Prevents text from wrapping
                            textOverflow: 'ellipsis', // Adds ellipsis at the end
                            maxWidth: '100%', // Adjust this value as needed
                            marginTop: '8px'
                        }}>
                            {/* Render 5 balls for the note */}
                            {[...Array(5)].map((_, index) => {
                                const fillPercentage = Math.min(Math.max(announce.note - index, 0), 1) * 100;
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            border: '1px solid #890608',
                                            marginRight: '4px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${fillPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#890608',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                    </div>
                                );
                            })}
                            {/* Display the number of reviews */}
                            <a href="#comment-section" style={{ textDecoration: 'underline', color: 'inherit' }}>
                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                    {visibleReviews.length} {visibleReviews.length === 1 ? t("annonce.labels.review") : t("annonce.labels.reviews")}
                                </span>
                            </a>
                        </div>
                        )}
                    </Typography>
                );
            case "evts":
                return (
                    <Typography>
                        <span>{announce.property.address.name || "Unknown Event"}</span>
                        {" | "}
                        <span>{getCountryName()}</span>
                        {" | Date: "}
                        {announce.property.eventDate || "TBA"}
                    </Typography>
                );
            case "trs":
                return (
                    <Typography>    
                         {/* Display duration if available */}
                         {(announce?.property?.trs_duration_days || announce?.property?.trs_duration_hours || announce?.property?.trs_duration_minutes) && (
                            <div style={{ marginTop: '4px' }}>
                                <span>
                                    {formatDuration({
                                        trs_duration_days: announce.property.trs_duration_days,
                                        trs_duration_hours: announce.property.trs_duration_hours,
                                        trs_duration_minutes: announce.property.trs_duration_minutes
                                    })}
                                </span>
                                <span>&nbsp;|&nbsp;</span> {/* Use &nbsp; for non-breaking spaces */}
                                <span>{announce?.property?.trs_frequency}</span>
                            </div>
                        )}
                        <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            overflow: 'hidden', // Ensures content doesn't overflow
                            whiteSpace: 'nowrap', // Prevents text from wrapping
                            textOverflow: 'ellipsis', // Adds ellipsis at the end
                            maxWidth: '100%', // Adjust this value as needed
                        }}>
                            {/* Render 5 balls for the note */}
                            {[...Array(5)].map((_, index) => {
                                const fillPercentage = Math.min(Math.max(announce.note - index, 0), 1) * 100;
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: '16px',
                                            height: '16px',
                                            borderRadius: '50%',
                                            border: '1px solid #890608',
                                            marginRight: '4px',
                                            position: 'relative',
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${fillPercentage}%`,
                                                height: '100%',
                                                backgroundColor: '#890608',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                            }}
                                        />
                                    </div>
                                );
                            })}
                            {/* Display the number of reviews */}
                            <a href="#comment-section" style={{ textDecoration: 'underline', color: 'inherit' }}>
                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                    {visibleReviews.length} {visibleReviews.length === 1 ? t("annonce.labels.review") : t("annonce.labels.reviews")}
                                </span>
                            </a>
                            <span style={{ marginLeft: '8px', marginRight: '8px' }}>&nbsp;|&nbsp;</span> {/* Use &nbsp; for non-breaking spaces */}
                            {announce.property.address.quartier ? (
                                <a 
                                    href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=${announce.property.address.quartier}&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                                    style={{ textDecoration: 'underline', color: 'inherit' }}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {announce.property.address.quartier}
                                </a>
                                ) : (
                                <span>N/A</span>
                            )}
                            <span>&nbsp;·&nbsp;</span> {/* Use &nbsp; for non-breaking spaces */}
                            <a 
                            href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                            style={{ textDecoration: 'underline', color: 'inherit' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {getCityName()}
                        </a>                     
                        </div>
                        {rankData.rank !== null && announce.rank > 0 && (
                            <div style={{ marginTop: '8px' }}>
                                <span>
                                    <strong>{t("ranking.number")} {announce.rank}</strong> {t("ranking.of")} {rankData.total} {t("ranking.restaurantsIn")}{' '}
                                    <a 
                                        href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=Restaurant&rooms=&luxury=false&perle=false&business=false`}
                                        style={{ textDecoration: 'underline', color: 'inherit' }}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {announce.property.address.city[i18n.language === "fr" ? "nomFR" : "nomEN"]}
                                    </a>
                                </span>
                            </div>
                        )}             
                        {announce?.property?.trs_typeDeCuisine && (
                            <div style={{ marginTop: '7px' }}>
                                <span>
                                    <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Cuisine:</span>
                                    <span> </span>
                                        {announce.property.trs_typeDeCuisine}
                                </span>
                            </div>
                        )}
                        
                    </Typography>
                );
            case "rstt":
                return (
                    <Typography>
                        <a 
                            href={`/search?search_pays=${announce.property.address.country._id}&search_adresse=${announce.property.address.city._id}&quartier=&offer=0&price=&priceMin=&currencyBase=XAF&currency=xaf&refreshData=1&travellerChildTotal=0&travellerAdultTotal=2&type=${announce.property.type.searchType.name}&page=1&dci=&dco=&eqt=&click=${announce.property.type.name}&rooms=&luxury=false&perle=false&business=false`}
                            style={{ textDecoration: 'underline', color: 'inherit' }}
                            target="_blank"
                            rel="noopener noreferrer"
                            >
                            {getCityName()}
                        </a>
                        {" | "}
                        <span>{getCountryName()}</span>
                    </Typography>
                );
            default:
                return null;
        }
    };

    const paymentLogos =
  announce.property?.address?.country.name === "Cameroon"
    ? [MTNMobileMoney_logo, OrangeMoney_logo, PayPal_logo, Visa2_logo, MasterCard_logo]
    : [PayPal_logo, Visa2_logo, MasterCard_logo];



    const phoneNumbers = [
        { number: "+237659797979", label: "numéro1" },
        { number: "+237655959595", label: "numéro2" },
        { number: "+237699982782", label: "numéro3" }
      ];

    const createWhatsAppMessage = (lang: string) => {
    
    const propertyType = announce.property.type.name;
    const propertyName = announce.property.name;
    const quartier = announce.property?.address?.quartier || t("label.unknownQuartier");
    const city = lang === 'fr' 
        ? announce.property?.address?.city?.nomFR || t("label.unknownCity")
        : announce.property?.address?.city?.nomEN || t("label.unknownCity");
    
    return lang === 'fr' 
        ? `Bonjour, je consulte l'annonce "${propertyType}: ${propertyName}" située à ${quartier}, ${city} sur AfriqPnB. J'aurais quelques questions à poser avant de poursuivre. Pourriez-vous m'assister ?`
        : `Hello, I'm viewing the listing "${propertyType}: ${propertyName}" in ${quartier}, ${city} on AfriqPnB. I have some questions before proceeding. Could you please assist me?`;
    };
    
    // Create WhatsApp URLs for all numbers
    const whatsappUrls = phoneNumbers.map(num => ({
    url: `https://wa.me/${num.number}?text=${encodeURIComponent(createWhatsAppMessage(i18n.language))}`,
    label: num.label
    }));

   
 

   
    

    return (
        <>
                <Helmet>
                    {/* Standard Meta Tags */}
                    <title data-rh="true">{pageTitle}</title>
                    <meta name="description" content={description} data-rh="true" />
                    <meta name="keywords" content={keywords} data-rh="true" />
                    <meta name="author" content="AfriqPnB" data-rh="true" />
                    <link rel="canonical" href={canonicalUrl} data-rh="true" />

                    {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
                    <meta property="og:title" content={pageTitle} data-rh="true" />
                    <meta property="og:description" content={description} data-rh="true" />
                    <meta property="og:url" content={canonicalUrl} data-rh="true" />
                    <meta property="og:site_name" content="AfriqPnB" data-rh="true" />
                    <meta property="og:type" content="website" data-rh="true" />
                    <meta 
                        property="og:image" 
                        content={ogImageUrl || "https://afriqpnb.com/static/media/fond_home_comp.webp"} 
                        data-rh="true" 
                    />
                    <meta 
                        property="og:image:secure_url" 
                        content={ogImageUrl || "https://afriqpnb.com/static/media/fond_home_comp.webp"} 
                        data-rh="true" 
                    />
                    <meta 
                        property="og:image:type" 
                        content={ogImageUrl?.endsWith('.webp') ? "image/webp" : "image/jpeg"} 
                        data-rh="true" 
                    />
                    <meta property="og:image:width" content="1200" data-rh="true" />
                    <meta property="og:image:height" content="630" data-rh="true" />
                    <meta 
                        property="og:image:alt" 
                        content={ogImageAlt || "Furnished apartment in " + announce.location} 
                        data-rh="true" 
                    />

                    {/* Twitter Card */}
                    <meta name="twitter:card" content="summary_large_image" data-rh="true" />
                    <meta name="twitter:title" content={pageTitle} data-rh="true" />
                    <meta name="twitter:description" content={description} data-rh="true" />
                    <meta 
                        name="twitter:image" 
                        content={ogImageUrl || "https://afriqpnb.com/static/media/fond_home_comp.webp"} 
                        data-rh="true" 
                    />
                    <meta name="twitter:site" content="@AfriqPnB" data-rh="true" />

                    {/* Structured Data (JSON-LD doesn't need data-rh) */}
                    <script type="application/ld+json" data-rh="true">
                        {JSON.stringify(schemaMarkup)}
                    </script>
                </Helmet>
    
            <div className={classes.container}>
                {loadingPage ? (
                    <div className={classes.loader}>
                        <PropagateLoader color="#36D7B7" size={15} />
                    </div>
                ) : (
                        
                    <>

                        {isStickyVisible && (
                            <CustomHidden mdUp>
                                <div className={classes.stickyFilterBar}>
                                    <Grid container spacing={1} alignItems="center" style={{ height: "40px"}}>                            
                                        <Grid item xs={6} sm={6} alignContent="center" style={{ height: "37px" }}>
                                            < StickyBarContactButton
                                                buttonClassName={classes.button}
                                                buttonStyle={{ background: "#25d366"}}
                                            />
                                        </Grid>
                                        <Grid item xs={6} sm={6} alignContent="center" >
                                            <Button
                                                onClick={toogleMap}
                                                color="primary"
                                                style={{ background: "#3a3939", height: "29px" }}
                                                className={classes.button}
                                                startIcon={<MapIcon />}
                                                endIcon={<KeyboardArrowDownIcon />}
                                            >
                                                {t("label.voir-sur-la-carte")}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </div>
                            </CustomHidden>
                        )}
                        {(user.role.name === ERoles.SUPER_ADMIN ||
                            user.role.name === ERoles.COUNTRY_ADMIN ||
                            user.role.name === ERoles.ADMIN_SUPPORT) && (
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                    fontSize: "14px",
                                    width: "100%",
                                }}
                            >
                                <span>{announce.state}</span>
                                <Link
                                    to={`/admin/announce/edit/${announce?._id}`}
                                    target="_blank"
                                    style={{ margin: "0 10px" }}
                                >
                                    <EditIcon />
                                </Link>
                            </div>
                        )}
                        {announce.promotion && (
                            <Typography>
                                <Grid container alignItems="center" spacing={1}>
                                    <Grid item>
                                        <span className={classes.promotionDiscount}>
                                            {t("annonce.labels.offreExceptionnelle")} - {announce.promotion.discount}% {t("annonce.labels.deReduction")}
                                        </span>
                                    </Grid>
                                    <Grid item>
                                        <span className={classes.promotionTitle}>
                                            {announce.promotion.title}
                                        </span>
                                    </Grid>
                                    <Grid item>
                                        <span className={classes.promotionDates}>
                                            {t("label.du")} {moment(announce.promotion.startDate).format("DD/MM/YYYY")} {t("annonce.labels.au")} {moment(announce.promotion.endDate).format("DD/MM/YYYY")}
                                        </span>
                                    </Grid>
                                </Grid>
                            </Typography>
                        )}
    
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item>
                                <h1>
                                    <span style={{ color: "#FF385C " }}>
                                        {announceTitle} :
                                    </span>{" "}
                                    {announce.property.name} {" · "} 
                                    {announce.property.address.city 
                                        ? announce.property.address.city[i18n.language === "fr" ? "nomFR" : "nomEN"]
                                        : "Unknown City"}
                                </h1>                                
                                <h2 style={{ fontSize: 15, fontWeight: 'normal', marginBottom: "20px" }}>
                                    {announce.property.address.quartier && 
                                    announce.property.address.city &&
                                    announce.property.address.city[i18n.language === "fr" ? "nomFR" : "nomEN"] &&
                                    announce.property.address.country &&
                                    announce.property.address.country[i18n.language === "fr" ? "nomFR" : "nomEN"]
                                        ? getTypographyContent(searchType)
                                        : "Information not available"}
                                </h2>                              
                            </Grid>
                            {(announce.property?.type.name === "Hôtel") && (
                                <Grid item>
                                    {tab_stars.length > 0 && tab_stars.map(() => (
                                        <Star style={{ color: "gold" }} />
                                    ))}
                                </Grid>
                            )}
                        </Grid>
                        <React.Suspense fallback={
                            <div style={{ width: '100%', height: '400px', background: '#f0f0f0' }}>
                                {<CircularProgress />}
                            </div>
                        }>
                            <AnnounceImageList photos={tab_photos} setShowToogleButtons={setShowToogleButtons} />
                        </React.Suspense>
    
                        {announce.property.address.street && isValidUrl(announce.property.address.street) && (
                            <div className={classes.section} style={{ marginBottom: 24 }}>
                                <Grid className={classes.localisationPropert}>
                                    <h4 style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                                        {t("listTable.labels.videoTitle")} :{" "}
                                    </h4>
                                    <div style={{ position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', maxWidth: '100%', borderRadius: "12px" }}>
                                        <iframe 
                                            title={" "}
                                            width="100%" 
                                            height="100%" 
                                            src={`https://www.youtube.com/embed/${extractYouTubeID(announce.property.address.street)}?rel=0`}
                                            frameBorder="0" 
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowFullScreen
                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                        ></iframe>
                                    </div>
                                </Grid>
                            </div>
                        )}
    
                        <div className={classes.section} style={{ marginBottom: 13 }}>
                        <Grid container spacing={2} alignItems="center">
                            {/* Left side - Reserve fixed height */}
                            <Grid item xs={8} md={6}>
                            <div style={{ 
                                display: "flex", 
                                flexWrap: "wrap", 
                                alignItems: "center",
                                minHeight: '60px' // Reserve space to prevent CLS
                            }}>
                                {searchType !== "cars" && (
                                <Hidden smDown>
                                    <HashLink smooth to={"#voir_la_carte"} style={{ marginRight: 46 }}>
                                    <Button 
                                        startIcon={<RoomRounded className={classes.btn_icon} />} 
                                        className={classes.btn_grey}
                                        style={{ minWidth: '160px' }} // Fixed width
                                    >
                                        {t("label.voir-sur-la-carte")}
                                    </Button>
                                    </HashLink>
                                </Hidden>
                                )}

                                {/* Conditionally rendered badges - use opacity instead of display:none */}
                                <div style={{ 
                                    display: "flex",
                                    opacity: searchType === "rstt" ? 0 : 1,
                                    visibility: searchType === "rstt" ? 'hidden' : 'visible',
                                    minHeight: '40px' // Reserve space
                                }}>
                                {searchType !== "rstt" && (
                                    <>
                                        {announce.ambassador && (
                                            <div style={{ marginRight: 20, minWidth: '80px' }}>
                                                <Typography className={classes.ambassador}>
                                                    {t("search.ambassador")}
                                                </Typography>
                                            </div>
                                        )}
                                        {announce.perle === "true" && (
                                            <div style={{ marginRight: 20, minWidth: '80px' }}>
                                                <Typography className={classes.listAttribut}>
                                                    {t("search.prestige")}
                                                </Typography>
                                            </div>
                                        )}
                                        {announce.luxury === "true" && (
                                            <div style={{ marginRight: 20, minWidth: '80px'  }}>
                                                <Typography className={classes.listAttribut}>
                                                    {t("search.premium")}
                                                </Typography>
                                            </div>
                                        )}
                                        {announce.business === "true" && (
                                            <div>
                                                <Typography className={classes.listAttribut}>
                                                    {t("search.standard")}
                                                </Typography>
                                            </div>
                                        )}
                                   </>
                                )}
                                </div>
                            </div>
                            </Grid>

                            {/* Right side - Reserve fixed height */}
                            <Grid item xs={4} md={6} style={{ 
                            display: 'flex', 
                            justifyContent: 'flex-end', 
                            alignItems: 'center', 
                            gap: '8px',
                            minHeight: '60px' // Reserve consistent height
                            }}>
                            {/* Share Button - always render but conditionally show */}
                            <Button
                                startIcon={<IosShareIcon />}
                                className={classes.btn_grey}
                                onClick={handleShare}
                                style={{ 
                                opacity: 1,
                                minWidth: '80px' // Fixed width
                                }}
                            >
                                <Hidden smDown>{t('annonce.share')}</Hidden>
                            </Button>

                            {/* Favorite Button - reserve space even when not logged in */}
                            <div style={{ 
                                minWidth: '120px',
                                minHeight: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                {user && user._id ? (
                                loadingChangeFavorite ? (
                                    <CircularProgress size={30} style={{ color: "#890608" }} />
                                ) : user?.favorites?.includes(announce._id) ? (
                                    <Button
                                    startIcon={<Favorite sx={{ color: "#890608" }} />}
                                    className={classes.btn_grey}
                                    onClick={() => onRemoveToFavorite(announce._id)}
                                    style={{ minWidth: '100px' }}
                                    >
                                    <Hidden smDown>{t('annonce.unsave')}</Hidden>
                                    </Button>
                                ) : (
                                    <Button
                                    startIcon={<FavoriteBorder sx={{ color: "#890608" }} />}
                                    className={classes.btn_grey}
                                    onClick={() => onAddToFavorite(announce._id)}
                                    style={{ minWidth: '100px' }}
                                    >
                                    <Hidden smDown>{t('annonce.save')}</Hidden>
                                    </Button>
                                )
                                ) : (
                                // Reserve space with invisible placeholder
                                <div style={{ width: '100px', height: '40px', visibility: 'hidden' }}></div>
                                )}
                            </div>
                            
                            {/* Admin view counter - reserve space */}
                            <div style={{ minWidth: '80px', minHeight: '40px' }}>
                                {(user.role.name === ERoles.SUPER_ADMIN || user.role.name === ERoles.COUNTRY_ADMIN || user.role.name === ERoles.ADMIN_SUPPORT) && (
                                <>
                                    <IconButton>
                                    <VisibilityIcon style={{ color: "#890608" }} />
                                    </IconButton>                                    
                                    <Typography variant="body2" color="textSecondary" style={{ marginRight: 10 }}>
                                    {viewCount}{" "}
                                    {viewCount === 1 ? t("detailBlog.view") : t("detailBlog.views")}
                                    </Typography>
                                </>
                                )}
                            </div>
                            </Grid>
                        </Grid>
                        </div>
    
                        <Grid container spacing={3}>
                            <Grid item lg={8} md={8} sm={12} xs={12}>
                                <div className={classes.section} style={{ marginBottom: 25 }}>
                                    <h3>{t("label.description")}</h3>
                                    <div dangerouslySetInnerHTML={createMarkup(announce.description as string)} className="text_body"></div>
                                </div>

                                {/* AdSense block LISTINGPAGE_MID_SLOT */}      

                                {/*<AdSenseAd slotId="4430165179" className={`${classes.adContainer} ${classes.midAd}`} />    */}                        
                                
    
                                <Grid container>
                                    <Grid item lg={searchType === "trs" ? 3 : 4} xs={12}>
                                        <div className={classes.section} style={{ marginBottom: 25 }}>
                                            <h3>{t("label.localisation")}</h3>
                                            <Grid className={classes.localisationPropert}>
                                            <h4 className={classes.h4Style}>
                                                {t("listTable.labels.pays")} :{" "}
                                                <span>
                                                    {i18n.language === "fr"
                                                        ? announce.property.address.country?.nomFR
                                                        : announce.property.address.country?.nomEN}
                                                </span>
                                            </h4>
                                            </Grid>
                                            <h4 className={classes.h4Style}>
                                                {announce.property.address.city && (
                                                    <Grid className={classes.localisationPropert}>
                                                        {t("listTable.labels.ville")} :{" "}
                                                        <span>
                                                            {i18n.language === "fr"
                                                                ? announce.property.address.city?.nomFR
                                                                : announce.property.address.city?.nomEN}
                                                        </span>
                                                    </Grid>
                                                )}
                                            </h4>    
                                            {(searchType === "apts" || searchType === "htls" || searchType === "trs") && (
                                                <h4 className={classes.h4Style}>                                                   
                                                    {announce.property.address.city?.name && (
                                                        <Grid className={classes.localisationPropert}>
                                                            {t("listTable.labels.quartier")} :{" "}
                                                            <span>
                                                                {announce.property.address.quartier}{" "}
                                                            </span>
                                                        </Grid>
                                                    )}
                                                </h4>
                                            )}
                                        </div>
                                    </Grid>
                                    <Grid item lg={searchType === "trs" ? 3 : 4} xs={12}>
                                        <div className={classes.section} style={{ marginBottom: 25 }}>
                                            { searchType === "trs" && (
                                                <h3>{t("label.media-cultural-details-trs")}</h3>
                                                )}
                                            { searchType !== "trs" && (
                                                <h3>{t("label.moreDetails")}</h3>
                                                )}
                                            {announce.property.address.street && (    
                                                <h4 className={classes.h4Style}>
                                                    {announce.property.address.city?.name && (
                                                        <Grid className={classes.localisationPropert}>
                                                            <OndemandVideoIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} /> 
                                                            <span>
                                                                {isValidUrl(announce.property.address.street) ? (
                                                                    <a 
                                                                        href={announce.property.address.street} target="_blank" rel="noopener noreferrer"
                                                                        style={{ textDecoration: 'underline', color: 'black' }}
                                                                    >
                                                                        {t("propriete.labels.trs_videoLink")}
                                                                    </a>
                                                                ) : (
                                                                    " " // Display an empty space for invalid URLs
                                                                )}
                                                            </span>
                                                        </Grid>
                                                    )}
                                                </h4>
                                            )}
                                            { searchType === "trs"  && (
                                                <>
                                                    {announce.property.trs_menu && (
                                                        <h4 className={classes.h4Style}>
                                                            {announce.property.address.city?.name && (
                                                                <Grid className={classes.localisationPropert}>
                                                                    <RestaurantMenuIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />    
                                                                    <a 
                                                                        href={announce.property.trs_menu} target="_blank" rel="noopener noreferrer"
                                                                        style={{ textDecoration: 'underline', color: 'black' }}
                                                                    >
                                                                        {t("propriete.labels.trs_menu")}
                                                                    </a>
                                                                </Grid>
                                                                
                                                            )}
                                                        </h4>
                                                    )}
                                                    {announce.property.trs_langage && (
                                                        <h4 className={classes.h4Style}>
                                                            {announce.property.address.city?.name && (
                                                                <Grid className={classes.localisationPropert}>
                                                                    <RecordVoiceOverIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />                                                                    
                                                                    <span>
                                                                        {announce.property.trs_langage}
                                                                    </span>
                                                                </Grid>
                                                            )}
                                                        </h4>
                                                    )}
                                                    
                                                </>
                                            )}
                                            { searchType === "cars"  && (
                                                <>
                                                    <h4 className={classes.h4Style}>
                                                        {announce.property.address.city?.name && (
                                                            <Grid className={classes.localisationPropert}>
                                                            {t("propriete.labels.type")} :{" "}
                                                            <span>
                                                                {`${announce.property.vhcl_brand} ${announce.property.vhcl_model}`}
                                                            </span>
                                                            </Grid>
                                                        )}
                                                    </h4>
                                                    <h4 className={classes.h4Style}>
                                                        {announce.property.address.city?.name && (
                                                            <Grid className={classes.localisationPropert}>
                                                            {t("propriete.labels.couleurExterne")} :{" "}
                                                            <span>
                                                                {t(`propriete.options.couleurs.${announce.property.vhcl_color}`)}
                                                            </span>
                                                            </Grid>
                                                        )}
                                                    </h4>
                                                    <h4 className={classes.h4Style}>
                                                        {announce.property.address.city?.name && (
                                                            <Grid className={classes.localisationPropert}>
                                                            {t("propriete.labels.enginePower")} :{" "}
                                                            <span>
                                                                {announce.property.vhcl_enginePower}
                                                            </span>
                                                            </Grid>
                                                        )}
                                                    </h4>
                                                    <h4 className={classes.h4Style}>
                                                        {announce.property.address.city?.name && (
                                                            <Grid className={classes.localisationPropert}>
                                                            {t("propriete.labels.carFuel")} :{" "}
                                                            <span>
                                                            {t(`propriete.labels.${announce.property.vhcl_fuelType}`)}
                                                            </span>
                                                            </Grid>
                                                        )}
                                                    </h4>
                                                    <h4 className={classes.h4Style}>
                                                        {announce.property.address.city?.name && (
                                                            <Grid className={classes.localisationPropert}>
                                                            {t("propriete.labels.gearBox")} :{" "}
                                                            <span>
                                                            {t(`propriete.labels.${announce.property.vhcl_gearBox}`)}
                                                            </span>
                                                            </Grid>
                                                        )}
                                                    </h4>
                                                </>    
                                            )}
                                        </div>
                                    </Grid>
                                    {searchType === "trs" && (
                                    <Grid item lg={searchType === "trs" ? 3 : 4} xs={12}>
                                        <div className={classes.section} style={{ marginBottom: 25 }}>
                                            { searchType === "trs" && (
                                                <h3>{t("label.contact-information-trs")}</h3>
                                                )}
                                            {announce.property.trs_address && (
                                                <h4 className={classes.h4Style}>
                                                    {announce.property.address.city?.name && (
                                                        <Grid className={classes.localisationPropert}>
                                                            <MailOutlineIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />    
                                                            <span>
                                                                <a 
                                                                    href={announce.property.trs_gpsLink} 
                                                                    target="_blank" 
                                                                    rel="noopener noreferrer"
                                                                    style={{ textDecoration: 'underline', color: 'black' }} // Add styles here
                                                                >
                                                                    {announce.property.trs_address}
                                                                </a>
                                                            </span>
                                                        </Grid>
                                                    )}
                                                </h4>
                                            )}
                                            {announce.property.trs_phoneNumber && (
                                                <h4 className={classes.h4Style}>
                                                    {announce.property.address.city?.name && (
                                                        <Grid className={classes.localisationPropert}>
                                                            <CallIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />
                                                            <span>
                                                                <a 
                                                                    href={`tel:${announce.property.trs_phoneNumber}`} 
                                                                    style={{ textDecoration: 'underline', color: 'black' }} // Underlined and black
                                                                >
                                                                    {announce.property.trs_phoneNumber}
                                                                </a>
                                                            </span>
                                                        </Grid>
                                                    )}
                                                </h4>
                                            )}     
                                            {announce.property.trs_website && (
                                                <h4 className={classes.h4Style}>
                                                    {announce.property.address.city?.name && (
                                                        <Grid className={classes.localisationPropert}>
                                                            <LanguageIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />    
                                                            <a 
                                                                href={announce.property.trs_website} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: 'underline', color: 'black' }} // Underlined and black
                                                            >
                                                                {t("propriete.labels.trs_website")}
                                                            </a>
                                                        </Grid>
                                                    )}
                                                </h4>
                                            )}
                                        </div>
                                    </Grid>
                                    )}

                                    { searchType !== "trs"  && (
                                 
                                    <Grid item lg={searchType === "trs" ? 3 : 4} xs={12}>
                                        <div className={classes.section} style={{ marginBottom: 25 }}>
                                            <h3>{t("label.tarification")}</h3>
                                            {priceConverted === 0 ? (
                                                <CircularProgress size={32} style={{ color: "#890608" }} />
                                            ) : (
                                                <>
                                                    <Grid className={classes.localisationPropert}>
                                                        <h4 className={classes.h4Style}>
                                                        {searchType === "rstt" ? t("label.price") : t("label.tarif-de-base")} : {priceConverted}
                                                        </h4>
                                                    </Grid>

                                                    {searchType !== "rstt" && (
                                                        <>
                                                            {announce.priceWeekly > 0 && (
                                                                <Grid className={classes.localisationPropert}>
                                                                    <h4 className={classes.h4Style}>
                                                                        {t("label.tarif-hebdomadaire")} :{" "}
                                                                        <span>
                                                                            {priceWeeklyConverted}/{t("label.tarif-hebdomadaire-detail")}
                                                                        </span>
                                                                    </h4>
                                                                </Grid>
                                                            )}
                                                            {announce.priceBiWeekly > 0 && (
                                                                <Grid className={classes.localisationPropert}>
                                                                    <h4 className={classes.h4Style}>
                                                                        {t("label.tarif-de-quinzaine")} :{" "}
                                                                        <span>
                                                                            {priceBiWeeklyConverted}/{t("label.tarif-de-quinzaine-detail")}
                                                                        </span>
                                                                    </h4>
                                                                </Grid>
                                                            )}
                                                            {announce.priceMonthly > 0 && (
                                                                <Grid className={classes.localisationPropert}>
                                                                    <h4 className={classes.h4Style}>
                                                                        {t("label.tarif-mensuel")} :{" "}
                                                                        <span>
                                                                            {priceMonthlyConverted}/{t("label.tarif-mensuel-detail")}
                                                                        </span>
                                                                    </h4>
                                                                </Grid>
                                                            )}
                                                        </> 
                                                    )}   
                                                </>
                                            )}
                                        </div>
                                        <Grid item xs={12}>
                                            <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
                                                {paymentLogos.map((logo, index) => (
                                                <Grid item key={index}>
                                                    <img
                                                    src={logo}
                                                    alt={`payment-method-${index}`}
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        objectFit: "contain",
                                                        borderRadius: "4px",
                                                    }}
                                                    />
                                                </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    )}
                                </Grid>
                                { searchType !== "trs"  && (
                                <Grid container>
                                    <Grid item lg={4} xs={12} style={{ marginTop: 40 }}>
                                        <div className={classes.section} style={{  marginTop: 25 }}>
                                            <h3>{t("detail-annonce.bookOnPhone")}</h3>
                                            
                                            <Grid style={{ 
                                                padding: 12, 
                                                marginTop: 0, 
                                                color: "black",
                                                textAlign: "left" // Changed from center to left
                                            }}>
                                                <div className="text_body" style={{ 
                                                    fontWeight: "normal", 
                                                    lineHeight: "1.5",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: "8px"
                                                }}>
                                                    {t("detail-annonce.contactServiceClient")}
                                                    
                                                    {whatsappUrls.map((whatsapp, index) => (
                                                        <div 
                                                            key={index} 
                                                            className={classes.phoneNumber}
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "8px",
                                                                lineHeight: "24px" // Match icon height
                                                            }}
                                                        >
                                                            <WhatsAppIcon 
                                                                style={{ 
                                                                    color: "#890608",
                                                                    fontSize: 24 // Fixed icon size
                                                                }} 
                                                            />
                                                            <a
                                                                href={whatsapp.url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{ 
                                                                    textDecoration: "none",
                                                                    color: "inherit",
                                                                    display: "inline-flex",
                                                                    alignItems: "center"
                                                                }}
                                                            >
                                                                {t(`detail-annonce.${whatsapp.label}`)}
                                                            </a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Grid>
                                        </div>
                                    </Grid>
                                </Grid>
                                )}
                               
    
                                <div className={classes.section} style={{ marginBottom: 32 }}>
                                    <h3 style={{ marginBottom: 15 }}>
                                        {t("detail-annonce.atouts")}
                                    </h3>
                                    <Grid container spacing={3} alignItems="center">
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <h4 style={{ marginBottom: 10 }}>
                                            {searchType === "rstt"
                                                ? t("detail-annonce.conditions")
                                                : searchType === "trs" && announce.property.type.name !== "Circuit"
                                                ? (
                                                    announce.property.trs_openingHours && (
                                                    <>
                                                        <QueryBuilderIcon style={{ color: '#890608', verticalAlign: 'middle', marginRight: '8px' }} />
                                                        {" "} {/* Add a space */}
                                                        {t("detail-annonce.openingHours")} {/* Wrap in curly braces */}
                                                    </>
                                                    )
                                                )
                                                : t("detail-annonce.reglement")}
                                            </h4>
                                        </Grid>
                                        {searchType === "trs" && announce.property.type.name !== "Circuit" && (
                                            <Grid item lg={5} md={7} sm={10} xs={10} style={{ marginLeft: '10px' }}>
                                                {announce.property.trs_openingHours && (
                                                    <div className="text_body" style={{ display: "grid", gridTemplateColumns: "auto auto", gap: "8px" }}>
                                                        {(Object.entries(announce.property.trs_openingHours) as [keyof OpeningHours, DayHours & { _id?: string }][]).map(
                                                            ([day, dayHours]) => {
                                                                // Filter out the `_id` field from the dayHours object
                                                                const { _id, ...filteredDayHours } = dayHours;
                                                                return (
                                                                    <React.Fragment key={day}>
                                                                        <div style={{ fontWeight: "bold" }}>{t(`label.${day}`)}</div>
                                                                        <div>
                                                                            {filteredDayHours.isClosed ? (
                                                                                t("label.closed")
                                                                            ) : (
                                                                                <>
                                                                                    <div>{`${filteredDayHours.open1} - ${filteredDayHours.close1}`}</div>

                                                                                    {filteredDayHours.hasSecondTimeSlot && (
                                                                                        <div>{`${filteredDayHours.open2} - ${filteredDayHours.close2}`}</div>
                                                                                    )}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </React.Fragment>
                                                                );
                                                            }
                                                        )}
                                                    </div>
                                                )}
                                            </Grid>
                                        )}

                                    {searchType !== "trs" && (
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <div dangerouslySetInnerHTML={createMarkup(announce.rules as string)} className="text_body"></div>
                                        </Grid>
                                    )}
    
                                        {searchType !== "cars" && searchType !== "evts" && searchType !== "rstt" && searchType !== "trs" && (
                                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                                {(announce.checkin || announce.checkout) && (
                                                    <span>
                                                        Check-in: {moment(announce.checkin).format("HH:mm")} Check-out: {moment(announce.checkout).format("HH:mm")}
                                                    </span>
                                                )}
                                            </Grid>
                                        )}
    
                                        {searchType !== "rstt" && (
                                        <>
                                            {(searchType === "apts" || searchType === "htls") && (
                                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                                    <div className={classes.icon} style={{ alignItems: "flex-start" }}>
                                                        <div className={classes.radius} style={{ border: "none" }}>
                                                            <CardTravelIcon style={{ fontSize: 32 }} />
                                                        </div>
                                                        <span>
                                                            {t("detail-annonce.garantie-de-protection")}
                                                        </span>
                                                    </div>
                                                </Grid>
                                            )}

                                            {searchType === "cars" ? (
                                                <Grid item lg={12} md={12} sm={12} xs={12} style={{ display: 'flex', gap: '16px', marginBottom: "15px" }}>
                                                    {announce.property.vhcl_passengers && (
                                                        <div className={classes.icon}>
                                                            <div className={classes.radius}>
                                                                <img alt="Maximum guests icon" src={traveller} width={32} />
                                                            </div>
                                                            <span className={classes.light}>
                                                                {t("detail-annonce.jusqu-a")} {announce.property.vhcl_passengers} {t("label.passagers")}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {announce.property.vhcl_bags && (
                                                        <div className={classes.icon}>
                                                            <div className={classes.radius}>
                                                                <img alt="Luggage icon" src={LuggageIcon} width={32} />
                                                            </div>
                                                            <span className={classes.light}>
                                                                {announce.property.vhcl_bags} {t("label.baggages")}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {announce.property.vhcl_doors && (
                                                        <div className={classes.icon}>
                                                            <div className={classes.radius}>
                                                                <img alt="Car door icon" src={carDoorIcon} width={32} />
                                                            </div>
                                                            <span className={classes.light}>
                                                                {announce.property.vhcl_doors} {t("label.portes")}
                                                            </span>
                                                        </div>
                                                    )}
                                                </Grid>
                                            ) : (searchType === "apts" || searchType === "htls") && (
                                                <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: "15px" }}>
                                                    <div className={classes.svgList}>
                                                        {announce.animaux ? (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <img src={paw} width={32} alt="icon" />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.animals")}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className={classes.icon} style={{ position: "relative" }}>
                                                                <div className={classes.radius}>
                                                                    <img src={paw} width={32} alt="icon" />
                                                                    <DoNotDisturbAltIcon style={{ fontSize: 70, position: "absolute", top: 4, left: 25 }} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.non-animals")}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {announce.enfant ? (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <EscalatorWarningIcon width={32} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.children")}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className={classes.icon} style={{ position: "relative" }}>
                                                                <div className={classes.radius}>
                                                                    <EscalatorWarningIcon width={32} />
                                                                    <DoNotDisturbAltIcon style={{ fontSize: 70, position: "absolute", top: 4, left: 29 }} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.non-children")}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {announce.fetes ? (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <CelebrationIcon width={32} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.fetes")}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div className={classes.icon} style={{ position: "relative" }}>
                                                                <div className={classes.radius}>
                                                                    <CelebrationIcon width={32} />
                                                                    <DoNotDisturbAltIcon style={{ fontSize: 70, position: "absolute", top: 4, left: 25 }} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.non-fetes")}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {announce.property.lit && (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <HotelIcon width={32} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {announce.property.lit}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {announce.property.bathrooms && (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <img alt="Bathroom icon" src={BathtubIcon} width={32} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {announce.property.bathrooms}
                                                                </span>
                                                            </div>
                                                        )}
                                                        {announce.property.maximumGuests && (
                                                            <div className={classes.icon}>
                                                                <div className={classes.radius}>
                                                                    <img alt="Maximum guests icon" src={traveller} width={32} />
                                                                </div>
                                                                <span className={classes.light}>
                                                                    {t("detail-annonce.jusqu-a")} {announce.property.maximumGuests} {t("home.voyaguers")}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </Grid>
                                            )}
                                        </>
                                    )}

                                    {searchType === "trs" && (
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <h4>
                                                {t("label.specificDetails")}
                                            </h4>
                                        </Grid>
                                    )}
    
                                    {tab_type && tab_type.map((type: any) => (
                                        <React.Fragment key={type.category}>
                                            {type.equipement.length > 0 && (
                                                <>
                                                    <Grid item lg={3} md={3} sm={3} xs={3}>
                                                        <span>{type.category}</span>
                                                    </Grid>

                                                    <Grid item lg={9} md={9} sm={9} xs={9}>
                                                        <span className={classes.light}>
                                                            {type.equipement.map((eq: any, index: number) => (
                                                                <React.Fragment key={eq._id}>
                                                                    {index === 0 ? (
                                                                        <>
                                                                            {eq.name[i18n.language] || eq.name.en}
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            / {eq.name[i18n.language] || eq.name.en}{" "}
                                                                        </>
                                                                    )}
                                                                </React.Fragment>
                                                            ))}
                                                        </span>
                                                    </Grid>
                                                </>
                                            )}
                                        </React.Fragment>
                                    ))}

                                    </Grid>
                                </div>
    
                                {searchType !== "evts" && searchType !== "trs" && searchType !== "rstt" && (
                                    <div className={classes.section} style={{ marginBottom: 25 }}>
                                        <h3 style={{ marginBottom: 32 }}>{t("detail-annonce.condition")}</h3>
                                        <span className={classes.refundItem}>
                                            {announce?.remboursable === "noremboursable" ? (
                                                <>
                                                    - {t("annonce.not-remb1")} {announce?.notRemboursable1} {t("annonce.not-remb2")}<br />
                                                    - {t("annonce.not-remb3")} {announce?.notRemboursable2} {t("annonce.not-remb4")}
                                                </>
                                            ) : (
                                                <>
                                                    1- {t("detail-annonce.refundItem11")} {announce?.freeRefundDay} {t("detail-annonce.refundItem12")}<br />
                                                    2- {t("detail-annonce.refundItem21")} {announce?.freeRefundDay} {t("detail-annonce.refundItem22")} {announce?.penaltyDayFees ?? "0"} {t("detail-annonce.refundItem23")}<br />
                                                    3- {t("detail-annonce.refundItem31")} {announce?.penaltyDayFeesAfterBookingStarted ?? "0"} {t("detail-annonce.refundItem32")}
                                                </>
                                            )}
                                        </span>
                                    </div>
                                )}
    
                                {searchType !== "cars" && searchType !== "trs" && (
                                    <Hidden smDown>
                                        <div className={classes.section} style={{ marginBottom: 25 }} id="voir_la_carte">
                                            <h3 style={{ marginBottom: 32 }}>{t("label.localiser-le-lieu")}</h3>
                                            {user.role.name === ERoles.SUPER_ADMIN || user.role.name === ERoles.COUNTRY_ADMIN || user.role.name === ERoles.ADMIN_SUPPORT ? (
                                                !isUpdating ? (
                                                    <Button className={classes.btn_red} onClick={changeLocationHandler}>
                                                        {t("annonce.labels.changer-localisation")}
                                                    </Button>
                                                ) : (
                                                    <Button className={classes.btn_red} onClick={handleUpdate}>
                                                        {t("propriete.buttonSave")}
                                                    </Button>
                                                )
                                            ) : null}
                                            {isUpdating && (
                                                <Button className={classes.btn_cancel} onClick={cancelUpdateHandler}>
                                                    {t("propriete.labels.annuler-la-modification")}
                                                </Button>
                                            )}
                                            <div className={classes.map}>
                                                {isUpdating ? (
                                                    <React.Suspense fallback={<CircularProgress />}>
                                                    <Map
                                                        width={1230}
                                                        alignStart={true}
                                                        updateLocation
                                                        setLocation
                                                        handleChange={setNewLocation}
                                                        startLongitude={boundaries.Center.lng}
                                                        startLatitude={boundaries.Center.lat}
                                                        oldLongitude={newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0 ? announce.property.location.longitude : newGeoLocation.longitude}
                                                        oldLatitude={newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0 ? announce.property.location.latitude : newGeoLocation.latitude}
                                                        onBoundariesChange={setBoundaries}
                                                        startZoom={boundaries.Zoom}
                                                        handleNext={handleUpdate}
                                                        isSearchingOnMap
                                                    />
                                                    </React.Suspense>
                                                ) : (
                                                    <React.Suspense fallback={<CircularProgress />}>
                                                    <Map
                                                        width={1230}
                                                        alignStart={true}
                                                        setPin={true}
                                                        startLongitude={newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0 ? announce.property.location.longitude : newGeoLocation.longitude}
                                                        startLatitude={newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0 ? announce.property.location.latitude : newGeoLocation.latitude}
                                                        onBoundariesChange={setBoundaries}
                                                        isSearchingOnMap
                                                        startZoom={13}
                                                    />
                                                    </React.Suspense>
                                                )}
                                            </div>
                                        </div>
                                    </Hidden>
                                )}

                                {searchType === "trs" && (
                                    <div className={classes.section} style={{ marginBottom: 25 }} id="voir_la_carte">
                                        <h3 style={{ marginBottom: 32 }}>{t("label.localiser-le-lieu")}</h3>    
                                        {announce.property.trs_address && (
                                            <h4 className={classes.h4Style}>
                                                {announce.property.address.city?.name && (
                                                    <Grid className={classes.localisationPropert}>
                                                        <MailOutlineIcon style={{ marginRight: 8, verticalAlign: 'middle', color: '#890608' }} />    
                                                        <span>
                                                            <a 
                                                                href={announce.property.trs_gpsLink} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                                style={{ textDecoration: 'underline', color: 'black' }} // Add styles here
                                                            >
                                                                {announce.property.trs_address}
                                                            </a>
                                                        </span>
                                                    </Grid>
                                                )}
                                            </h4>
                                        )}

                                        <div className={classes.map}>
                                            {/* Replace Mapbox with Google Maps Embed */}
                                            <GoogleMapsEmbed url={announce.property.trs_embedLink} />
                                        </div>
                                    </div>
                                )}
    
                                {searchType !== "evts" && searchType !== "trs" && searchType !== "rstt" && (
                                    <>
                                        <Dialog open={openDialog} maxWidth="sm">
                                            <DialogTitle style={{ padding: 0 }}>
                                                <div className={classes.titleDialog}>
                                                    <span className={classes.title}>
                                                        {t("label.confirmation-indisponibilite")}
                                                    </span>
                                                    <IconButton aria-label="close" onClick={handleClose}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </div>
                                            </DialogTitle>
                                            <DialogContent className={classes.contentDialog}>
                                                {t("label.voulez-vous-mettre-indisponibilite")}{" "}
                                                {moment(indisponible).format("DD/MM/YYYY")}
                                            </DialogContent>
                                            <DialogActions className={classes.actionsDialog}>
                                                <Button variant="contained" className={classes.annuler} style={{ textTransform: "none" }} onClick={handleClose}>
                                                    {t("reservation.button.cancel")}
                                                </Button>
                                                <Button variant="contained" className={classes.valider} style={{ textTransform: "none" }} onClick={handleInDisponibilite}>
                                                    {t("reservation.button.valider")}
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
    
                                        <Dialog open={openDialogDisponible} maxWidth="sm">
                                            <DialogTitle style={{ padding: 0 }}>
                                                <div className={classes.titleDialog}>
                                                    <span className={classes.title}>
                                                        {t("label.confirmation-disponibilite")}
                                                    </span>
                                                    <IconButton aria-label="close" onClick={handleCloseDisponible}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </div>
                                            </DialogTitle>
                                            <DialogContent className={classes.contentDialog}>
                                                {t("label.voulez-vous-mettre-disponible")}{" "}
                                                {moment(disponible).format("DD/MM/YYYY")}
                                            </DialogContent>
                                            <DialogActions className={classes.actionsDialog}>
                                                <Button variant="contained" className={classes.annuler} style={{ textTransform: "none" }} onClick={handleCloseDisponible}>
                                                    {t("reservation.button.cancel")}
                                                </Button>
                                                <Button variant="contained" className={classes.valider} style={{ textTransform: "none" }} onClick={handleDisponibilite}>
                                                    {t("reservation.button.valider")}
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
    
                                        <div className={classes.section} style={{ marginBottom: 50 }}>
                                            <h3>{t("detail-annonce.disponibility")}</h3>
                                                <Calendar
                                                    localizer={localizer}
                                                    longPressThreshold={500}
                                                    events={tab_reservation}
                                                    startAccessor="start"
                                                    endAccessor="end"
                                                    onSelectEvent={onSelectingAnEvent}
                                                    onSelectSlot={user._id === announce.owner._id ? onSelecting : undefined}
                                                    selectable={user._id === announce.owner._id}
                                                    style={{ height: 350 }}
                                                    eventPropGetter={(event: any) => ({
                                                        style: event.title === t("label.offres-exceptionnelles") ? { backgroundColor: "#FFC000", color: "#000000" } : {},
                                                    })}
                                                    messages={{
                                                        today: `${t("calendar.today")}`,
                                                        previous: `${t("calendar.back")}`,
                                                        next: `${t("calendar.next")}`,
                                                        month: `${t("calendar.month")}`,
                                                        week: `${t("calendar.week")}`,
                                                        day: `${t("calendar.day")}`,
                                                        agenda: `${t("calendar.agenda")}`,
                                                    }}
                                                    views={{ month: true }}
                                                />
                                        </div>
                                    </>
                                )}
    
                                <div
                                    className={classes.section}
                                    style={{ marginBottom: 72 }}
                                >
                                    <div className={classes.avatar}>
                                        {announce.owner?.avatar ? (
                                            <Avatar
                                                alt="AfriqPnB Host"
                                                src={`${Env.ApiRoot}/images/avatars/${announce.owner?.avatar}`}
                                                className={classes.avatarImg}
                                            />
                                        ) : (
                                            <Avatar
                                                alt="AfriqPnB Host"
                                                src={avatar_empty}
                                                className={classes.avatarImg}
                                            />
                                        )}

                                        
                                        <div className={classes.host}>
                                            <span>
                                                {t("label.propose-par")}{" "}
                                                {announce.owner?.firstName}
                                            </span>
                                        </div>
                                        
                                    </div>
                                </div>

                                {/* AdSense LISTINGPAGE_BOTTOM_SLOT */}
                                 {/*<AdSenseAd slotId="4101361684" className={`${classes.adContainer} ${classes.bottomAd}`} />   */}  


                                {announce.property?.adPictures?.length > 0 && (
                                    <AdPicturesCarousel 
                                        photos={announce.property.adPictures} 
                                        adUrl={announce.property.adUrl}
                                    />
                                )}                                

                                <div id="review-section" className={classes.section} style={{ marginTop: 30, marginBottom: 30 }}>
                                    <Grid container alignItems="center" style={{ fontSize: 16, fontWeight: "bold" }}>
                                        {/* Display averageRating with fontSize 26 */}
                                        <span style={{ fontSize: 26, marginRight: 8 }}>
                                            {visibleReviews.length !== 0 ? averageRating : 0}
                                        </span>
                                        
                                        {/* Star rating display */}
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {[...Array(5)].map((_, index) => {
                                                const fillPercentage = Math.min(Math.max(announce.note - index, 0), 1) * 100;
                                                return (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            width: '16px',
                                                            height: '16px',
                                                            borderRadius: '50%',
                                                            border: '1px solid #890608',
                                                            marginRight: '4px',
                                                            position: 'relative',
                                                            overflow: 'hidden',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: `${fillPercentage}%`,
                                                                height: '100%',
                                                                backgroundColor: '#890608',
                                                                position: 'absolute',
                                                                top: 0,
                                                                left: 0,
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            })}
                                        </div>

                                        {/* Replace Brightness1 with a space */}
                                        <span style={{ marginLeft: 4, marginRight:4}}> </span>

                                        {/* Display number of reviews */}
                                        {visibleReviews.length}{" "}
                                        <span style={{ marginLeft: 5 }}>
                                            {visibleReviews.length === 1 ? t("annonce.labels.review") : t("annonce.labels.reviews")}
                                        </span>
                                    </Grid>
                                </div>                           

                                {canComment && (
                                <>
                                    {/* Show the "Add a Review" button for non-admin users */}
                                    {!(user?.role?.name === ERoles.COUNTRY_ADMIN ||
                                    user?.role?.name === ERoles.ADMIN_SUPPORT ||
                                    user?.role?.name === ERoles.SUPER_ADMIN) && !showForm && (
                                        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={toggleFormVisibility}
                                                style={{
                                                    backgroundColor: "#890608",  // Dark red background
                                                    color: "white",     
                                                    borderRadius: 8,
                                                    padding: "10px 20px",
                                                }}
                                                type="button" // Add this line
                                            >
                                                {t("label.ajoutez-votre-commentaire")}
                                            </Button>
                                        </div>
                                    )}

                                    {/* Show the form if showForm is true or if the user is an admin */}
                                    {(showForm ||
                                        user?.role?.name === ERoles.COUNTRY_ADMIN ||
                                        user?.role?.name === ERoles.ADMIN_SUPPORT ||
                                        user?.role?.name === ERoles.SUPER_ADMIN) && (
                                    <>    
                                        <form
                                            id="comment-form"
                                            className={classes.section}
                                            style={{
                                                maxWidth: 800,
                                                backgroundColor: '#fff', // White background for the form
                                                borderRadius: 15, // Rounded corners
                                                padding: '20px 30px', // Internal padding
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for elevation
                                                marginBottom: '30px' // Space below the form
                                            }}
                                            noValidate
                                            autoComplete="off"
                                            onSubmit={handleSubmit}
                                        >
                                            <h3 style={{ 
                                                marginBottom: '16px',
                                                fontSize: '20px',
                                                fontWeight: 'bold'
                                            }}>
                                                {t("rating.experienceQuestion")}
                                            </h3>
                                            <Grid container>
                                                {/*<Grid item xs={12} style={{ width: 70, marginBottom: 10 }}>
                                                    {user.avatar ? (
                                                        <Avatar alt="User avatar" src={`${Env.ApiRoot}/images/avatars/${user.avatar}`} style={{ width: 30, height: 30, opacity: 0.4 }} />
                                                    ) : (
                                                        <AccountCircleIcon style={{ width: 30, height: 30, opacity: 0.4 }} />
                                                    )}
                                                </Grid> */}
                                                <Grid item xs={12} style={{ flex: 1 }}>
                                                <div style={{ 
                                                    display: "flex", 
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                    gap: "8px",
                                                    marginBottom: '30px'
                                                }}>
                                                    <StarRating 
                                                    value={note} 
                                                    showLabel={true}
                                                    onChange={(newValue) => {
                                                        setNote(newValue);
                                                        setReview({
                                                        ...review,
                                                        note: newValue,
                                                        });
                                                    }}
                                                    starSize={24} //set the larger star size here
                                                    key={`star-rating-${note}`} // Add key to force re-render
                                                    />
                                                </div>

                                                    {/* Dynamic Rating Criteria Based on searchType */}
                                                    {(searchType === "apts" || searchType === "htls"
                                                        ? [
                                                            t("label.cleanliness"),
                                                            t("label.accuracy"),
                                                            t("label.communication"),
                                                            t("label.location"),
                                                            t("label.checkIn"),
                                                            t("label.value"),
                                                        ] // Accommodation criteria
                                                        : searchType === "cars"
                                                        ? [
                                                            t("label.vehicleCondition"),
                                                            t("label.customerService"),
                                                            t("label.easeOfBookingAndPickup"),
                                                            t("label.valueForMoney"),
                                                        ] // Car rental criteria
                                                        : searchType === "trs"
                                                        ? (() => {
                                                            // Ensure announce.property.type.name is defined
                                                            const propertyType = announce?.property?.type?.name || "default";
                                                            switch (propertyType) {
                                                                case "restaurant":
                                                                    return [
                                                                        t("label.foodQuality"),
                                                                        t("label.serviceQuality"),
                                                                        t("label.ambiance"),
                                                                        t("label.cleanliness"),
                                                                        t("label.valueForMoney"),
                                                                    ];
                                                                case "nightlife":
                                                                    return [
                                                                        t("label.entertainmentActivities"),
                                                                        t("label.drinkQuality"),
                                                                        t("label.ambiance"),
                                                                        t("label.serviceQuality"),
                                                                        t("label.valueForMoney"),
                                                                    ];
                                                                case "spa":
                                                                    return [
                                                                        t("label.serviceQuality"),
                                                                        t("label.cleanliness"),
                                                                        t("label.comfort"),
                                                                        t("label.ambiance"),
                                                                        t("label.valueForMoney"),
                                                                    ];
                                                                case "attraction":
                                                                    return [
                                                                        t("label.entertainmentActivities"),
                                                                        t("label.serviceQuality"),
                                                                        t("label.cleanliness"),
                                                                        t("label.valueForMoney"),
                                                                        t("label.location"),
                                                                    ];
                                                                case "site historique":
                                                                    return [
                                                                        t("label.historicalSignificance"),
                                                                        t("label.cleanliness"),
                                                                        t("label.serviceQuality"),
                                                                        t("label.valueForMoney"),
                                                                        t("label.location"),
                                                                    ];
                                                                case "musée":
                                                                    return [
                                                                        t("label.exhibitsQuality"),
                                                                        t("label.cleanliness"),
                                                                        t("label.serviceQuality"),
                                                                        t("label.valueForMoney"),
                                                                        t("label.location"),
                                                                    ];
                                                                default:
                                                                    // Fallback for undefined or unknown property types
                                                                    return [
                                                                        t("label.serviceQuality"),
                                                                        t("label.cleanliness"),
                                                                        t("label.valueForMoney"),
                                                                        t("label.location"),
                                                                    ];
                                                            }
                                                        })()
                                                        : [] // Default case (no criteria)
                                                    ).map((ratingType, index) => {
                                                        // Define `ratingKey` based on the searchType
                                                        const ratingKey = (() => {
                                                            if (searchType === "apts" || searchType === "htls") {
                                                                switch (index) {
                                                                    case 0: return "cleanliness";
                                                                    case 1: return "accuracy";
                                                                    case 2: return "communication";
                                                                    case 3: return "location";
                                                                    case 4: return "checkin";
                                                                    case 5: return "value";
                                                                    default: return "";
                                                                }
                                                            } else if (searchType === "cars") {
                                                                switch (index) {
                                                                    case 0: return "vehiclecondition";
                                                                    case 1: return "customerservice";
                                                                    case 2: return "easeofbookingandpickup";
                                                                    case 3: return "valueformoney";
                                                                    default: return "";
                                                                }
                                                            } else if (searchType === "trs") {
                                                                const propertyType = announce?.property?.type?.name || "default";
                                                                switch (propertyType) {
                                                                    case "restaurant":
                                                                        return ["foodquality", "servicequality", "ambiance", "cleanliness", "valueformoney"][index];
                                                                    case "nightlife":
                                                                        return ["entertainmentactivities", "drinkquality", "ambiance", "servicequality", "valueformoney"][index];
                                                                    case "spa":
                                                                        return ["servicequality", "cleanliness", "comfort", "ambiance", "valueformoney"][index];
                                                                    case "attraction":
                                                                        return ["entertainmentactivities", "servicequality", "cleanliness", "valueformoney", "location"][index];
                                                                    case "site historique":
                                                                        return ["historicalsignificance", "cleanliness", "servicequality", "valueformoney", "location"][index];
                                                                    case "musée":
                                                                        return ["exhibitsquality", "cleanliness", "servicequality", "valueformoney", "location"][index];
                                                                    default:
                                                                        // Fallback for undefined or unknown property types
                                                                        return ["servicequality", "cleanliness", "valueformoney", "location"][index];
                                                                }
                                                            } else {
                                                                return "";
                                                            }
                                                        })() as keyof ReviewInputs; // Use type assertion here

                                                        // Debugging: Log the ratingKey and review state
                                                        //console.log("ratingKey:", ratingKey, "review[ratingKey]:", review[ratingKey]);

                                                        return (
                                                            <div
                                                                key={ratingType}
                                                                style={{
                                                                    display: 'flex',
                                                                    flexDirection: 'row',
                                                                    justifyContent: 'space-between',
                                                                    alignItems: 'center',
                                                                    marginTop: 16, // Increased from 10 to 16 for better spacing
                                                                    width: '100%',                                                                    
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-start',
                                                                        alignItems: 'center',
                                                                        width: '50%', // Increased from 25% to accommodate longer text
                                                                    }}
                                                                >
                                                                    <Typography component="legend" style={{
                                                                        fontSize: '16px',
                                                                        fontWeight: 500,
                                                                    }}>
                                                                        {ratingType}
                                                                    </Typography>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'flex-end',
                                                                        alignItems: 'center',
                                                                        width: '30%', // Adjusted to match new layout
                                                                    }}
                                                                >
                                                                    <StarRating
                                                                        value={
                                                                        typeof review[ratingKey] === "number"
                                                                            ? (review[ratingKey] as number)
                                                                            : null
                                                                        }
                                                                        showLabel={false}
                                                                        onChange={(newValue) => {
                                                                        setReview({
                                                                            ...review,
                                                                            [ratingKey]: newValue,
                                                                        });
                                                                        }}
                                                                        starSize={20} 
                                                                    />
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    <div style = {{ marginTop: 30}}>

                                                    </div>

                                                    {searchType === "trs" && (                                                   
                                                        <TextField
                                                            id="experience-date"
                                                            label={t("label.dateOfExperience")}
                                                            variant="outlined"
                                                            type="date"
                                                            fullWidth
                                                            margin="normal"
                                                            InputLabelProps={{ shrink: true }}
                                                            value={experienceDate || ""}
                                                            onChange={(event) => setExperienceDate(event.target.value)}
                                                            style={{ backgroundColor: '#fff', borderRadius: 8, marginTop: 12}}
                                                        />
                                                    )}

                                                    {/* Comment Input */}
                                                
                                                    <TextField
                                                        id="commentTitle"
                                                        label={t("label.commentTitle")}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        value={commentTitle || ""}
                                                        onChange={onChangeCommentTitle} // <-- Use the correct handler
                                                        style={{ backgroundColor: '#fff', borderRadius: 8 }}
                                                    />
                                                    <TextField
                                                        id="outlined-multiline-static"
                                                        multiline
                                                        rows={4}
                                                        value={comment}
                                                        placeholder={t("label.commentaire")}
                                                        variant="outlined"
                                                        style={{
                                                            width: "100%",
                                                            margin: "20px 0",
                                                            backgroundColor: '#fff', // White background for the input
                                                            borderRadius: 8, // Rounded corners for the input
                                                        }}
                                                        onChange={onChangeComment}
                                                    />
                                                                                                 
                                                    {searchType === "trs" && (
                                                        <div>
                                                            <div style={{ margin: '20px 0', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                <label htmlFor="picture-upload" style={{
                                                                    padding: '8px 16px',
                                                                    backgroundColor: '#890608',
                                                                    color: 'white',
                                                                    borderRadius: '4px',
                                                                    cursor: 'pointer',
                                                                    fontSize: '14px'
                                                                }}>
                                                                    {t('picture_upload.add_button')}
                                                                </label>
                                                                <span style={{ fontSize: '14px', color: '#666' }}>
                                                                    {t('picture_upload.counter', { 
                                                                        count: pictures.length, 
                                                                        max: MAX_PICTURES 
                                                                    })}
                                                                </span>
                                                                <input
                                                                    accept="image/*"
                                                                    id="picture-upload"
                                                                    type="file"
                                                                    multiple
                                                                    onChange={handleFileChange}
                                                                    style={{ display: 'none' }}
                                                                    disabled={pictures.length >= MAX_PICTURES}
                                                                    title={pictures.length >= MAX_PICTURES ? 
                                                                        t('picture_upload.limit_reached', { max: MAX_PICTURES }) : 
                                                                        undefined
                                                                    }
                                                                />
                                                            </div>
                                                            
                                                            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                                                {pictures.map((pic, index) => (
                                                                    <div key={index} style={{ position: 'relative' }}>
                                                                        <img 
                                                                            src={URL.createObjectURL(pic)} 
                                                                            alt={t('picture_upload.alt_text', { index: index + 1 })} 
                                                                            style={{ 
                                                                                width: "100px", 
                                                                                height: "100px", 
                                                                                objectFit: "cover", 
                                                                                borderRadius: "8px",
                                                                                border: '1px solid #ddd'
                                                                            }} 
                                                                        />
                                                                        <button
                                                                            onClick={() => removePicture(index)}
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '-10px',
                                                                                right: '-10px',
                                                                                background: '#ff4444',
                                                                                color: 'white',
                                                                                border: 'none',
                                                                                borderRadius: '50%',
                                                                                width: '24px',
                                                                                height: '24px',
                                                                                cursor: 'pointer',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontSize: '12px'
                                                                            }}
                                                                            aria-label={t('picture_upload.remove_aria')}
                                                                        >
                                                                            ×
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div style={{ marginTop: 20, marginBottom: 20}}>
                                                        <FormControlLabel
                                                            control={
                                                                <Checkbox
                                                                    checked={isCertified}
                                                                    onChange={(event) => setIsCertified(event.target.checked)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={
                                                                <Typography variant="body2">
                                                                    {t("label.disclaimer")}
                                                                </Typography>
                                                            }
                                                        />
                                                    </div>
                                                 
                                                    {/*
                                                    {searchType === "trs" && (user?._id === "") && (
                                                        <>
                                                            <TextField
                                                                id="surname"
                                                                label={t("label.surname")}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                value={surname || ""}
                                                                onChange={(event) => setSurname(event.target.value)}
                                                                style={{ backgroundColor: '#fff', borderRadius: 8 }}
                                                            />
                                                            <TextField
                                                                id="last-name"
                                                                label={t("label.lastName")}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                value={lastName || ""}
                                                                onChange={(event) => setLastName(event.target.value)}
                                                                style={{ backgroundColor: '#fff', borderRadius: 8 }}
                                                            />
                                                            <TextField
                                                                id="email"
                                                                label={t("label.email")}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                value={email || ""}
                                                                onChange={(event) => setEmail(event.target.value)}
                                                                style={{ backgroundColor: '#fff', borderRadius: 8 }}
                                                            />
                                                            <Grid container spacing={1}>
                                                                <Grid item lg={4} md={4} sm={4} xs={4}>
                                                                    <SelectEndornmentNation
                                                                        id="country"
                                                                        name="country"
                                                                        values={CountryPhoneList}
                                                                        IconElement={
                                                                            logo ? (
                                                                                <img
                                                                                    style={{ width: 32 }}
                                                                                    src={`${logo}`}
                                                                                    alt={"Flag"}
                                                                                />
                                                                            ) : (
                                                                                ""
                                                                            )
                                                                        }
                                                                        selectedValue=""
                                                                        handleOnChange={(key: string, value: string) => {
                                                                            // Handle country selection
                                                                            setReview({ ...review, [key]: value });
                                                                        }}
                                                                        handleOnChangeNation={(val: any) => {
                                                                            // Handle country code and flag
                                                                            setCodePhone(val.dial_code);
                                                                            setLogoPays(val.code);
                                                                        }}
                                                                    />
                                                                </Grid>
                                                                <Grid item lg={8} md={8} sm={8} xs={8}>
                                                                    <Stack direction="row" alignItems="center" display="flex">
                                                                        <TextField
                                                                            margin="dense"
                                                                            id="phone"
                                                                            name="numberPhone"
                                                                            variant="outlined"
                                                                            onChange={(event) => {
                                                                                // Handle phone number input
                                                                                setPhoneNumber(event.target.value)}     
                                                                            }                                                                   
                                                                            value={phoneNumber || ""}
                                                                            type="text"
                                                                            classes={{ root: classes.textField }}
                                                                            fullWidth
                                                                            label={`${t("SignUp.phone")}*`}
                                                                            InputProps={{
                                                                                startAdornment: (
                                                                                    <div style={{ marginRight: 10 }}>
                                                                                        {codephone} 
                                                                                    </div>
                                                                                ),
                                                                                classes: { input: classes["input"] },
                                                                            }}
                                                                            style={{ backgroundColor: '#fff', borderRadius: 8 }}
                                                                        />
                                                                    </Stack>
                                                                </Grid>
                                                            </Grid>
                                                            
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={isCertified}
                                                                        onChange={(event) => setIsCertified(event.target.checked)}
                                                                        color="primary"
                                                                    />
                                                                }
                                                                label={
                                                                    <Typography variant="body2">
                                                                        {t("label.disclaimer")}
                                                                    </Typography>
                                                                }
                                                            />
                                                        </>
                                                    )} */}

                                                    {/* Additional Input Fields for All searchTypes */}
                                                    { (user?.role?.name === ERoles.COUNTRY_ADMIN ||
                                                        user?.role?.name === ERoles.ADMIN_SUPPORT ||
                                                        user?.role?.name === ERoles.SUPER_ADMIN)  && (
                                                        <>    
                                                            <TextField
                                                                id="visible-author"
                                                                label={t("label.visibleAuthor")}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                                value={review.visibleAuthor || ""}
                                                                onChange={(event) => {
                                                                    setReview({
                                                                        ...review,
                                                                        visibleAuthor: event.target.value,
                                                                    });
                                                                }}
                                                                style={{
                                                                    backgroundColor: '#fff', // White background for the input
                                                                    borderRadius: 8, // Rounded corners for the input
                                                                }}
                                                                placeholder={t("label.entrez-visible-author")}
                                                            />
                                                            <TextField
                                                                id="visible-date"
                                                                label={t("label.visibleDate")}
                                                                variant="outlined"
                                                                type="date"
                                                                fullWidth
                                                                margin="normal"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                value={
                                                                    review.visibleDate && !isNaN(review.visibleDate.getTime())
                                                                        ? review.visibleDate.toISOString().split("T")[0]
                                                                        : ""
                                                                }
                                                                onChange={(event) => {
                                                                    const newDate = new Date(event.target.value);
                                                                    if (!isNaN(newDate.getTime())) {
                                                                        // Only update if the date is valid
                                                                        setReview({
                                                                            ...review,
                                                                            visibleDate: newDate,
                                                                        });
                                                                    }
                                                                }}
                                                                style={{
                                                                    backgroundColor: '#fff', // White background for the input
                                                                    borderRadius: 8, // Rounded corners for the input
                                                                }}
                                                                placeholder={t("label.entrez-visible-date")}
                                                            />
                                                        </>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                className={classes.btnComment}
                                                style={{
                                                    backgroundColor: '#890608',
                                                    color: 'white',
                                                    borderRadius: 8,
                                                    padding: '10px 20px'
                                                }}
                                                >
                                                {t("label.commenter")}
                                            </Button>
                                            </div>
                                        </form>
                                        <LoginDialog
                                            open={loginDialogOpen}
                                            handleClose={handleLoginDialogClose}
                                            handleClickOpenRegister={handleClickOpenRegister}
                                            redirectState={reviewFormState}
                                            redirectPath={`/exp_${propertyType}/${slug}/${city}/${region}/${id}#review-section`}
                                            onLoginSuccess={handleLoginSuccess} // Pass the callback function
                                        />
                                        <RegisterDialog
                                            open={openRegister}
                                            handleClose={handleCloseRegister}
                                            handleOpenLoginDialog={handleClickOpenLoginDialog}
                                            redirectPath={history.location.pathname + history.location.search}
                                        />
                                        </>
                                    )}
                                </>
                            )}

                                    <div 
                                        id="comment-section"
                                        className={classes.section}
                                        style={{
                                            marginBottom: 72,
                                            backgroundColor: '#fff', // White background for the comments section
                                            borderRadius: 15, // Rounded corners for the comments section
                                            padding: '20px 30px', // Internal padding
                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)', // Optional shadow for elevation
                                        }}
                                    >
                                        <h3 style={{ marginBottom: 32 }}>{t("detail-annonce.comments")}</h3>
                                        <Grid container justifyContent="space-between" className={classes.comment_card}>
                                            {commentSection()}
                                        </Grid>

                                        {/*<div style={{ display: "flex", justifyContent: "center" }}>
                                            <AfriqGreyButton
                                                style={{
                                                    marginTop: 50,
                                                    width: 300,
                                                    borderRadius: 8, // Rounded corners for the button
                                                    padding: '10px 20px', // Internal padding for the button
                                                }}
                                                onClick={() => setShowAllComment(!showAllComment)}
                                            >
                                                {showAllComment ? t("label.les-commentaires-limit") : t("label.les-commentaires")}
                                            </AfriqGreyButton>
                                        </div> */}
                                    </div>

                                {/* AdSense LISTINGPAGE_AFTER_COMMENTS_SLOT */}
                                 {/*<AdSenseAd slotId="3909789993" className={`${classes.adContainer} ${classes.postCommentsAd}`} />      */}
                                
                                
                                {announce.property.type.searchType.name === 'htls' && hotelAnnounces.length > 0 && (
                                    <div style={{ marginTop: 30 , marginBottom: 30 }}>
                                        <h2 style={{ fontSize: 16.5, fontWeight: 'bold', marginBottom: "20px" }}>
                                            {announce.property.type.searchType.name === 'htls' 
                                                ? t("detailBlog.listings-from-same-hotel") 
                                                : t("detailBlog.listings-from-same-apartment")}
                                        </h2>
                                        <HotelCarousel                                        
                                            onAddToFavorite={props.onAddToFavorite}
                                            onRemoveToFavorite={props.onRemoveToFavorite}
                                            user={props.user}
                                            searchType={announce.property.type.searchType.name}
                                            hotelId={hotelId}
                                            commissionFee={commissionFee}
                                        />
                                    </div>
                                )}

                               
                                <h3 style={{ fontSize: 10 , fontWeight: 'normal', marginBottom: 10 }}>
                                    {t("detail-annonce.reference")} : {announce._idRef} 
                                </h3>                                
                                <h3 style={{ marginBottom: 15 }}>{t('label.navigation')}</h3>
                                <nav aria-label="breadcrumb" className={classes.breadcrumbNav}>
                                <ol className={classes.breadcrumbList}>
                                    {/* For large screens: Display breadcrumbs in a horizontal line */}
                                    <Hidden xsDown> {/* This will hide the content on mobile devices */}
                                    <li className={`${classes.breadcrumbItem} ${classes.breadcrumbItemLarge}`}>
                                        <a href="/" className={classes.breadcrumbLink}>AfriqPnB</a>
                                        <span className={classes.separator}>{" > "}</span>
                                    </li>
                                    <li className={`${classes.breadcrumbItem} ${classes.breadcrumbItemLarge}`}>
                                        <a href={`/${announceType}`} className={classes.breadcrumbLink}>
                                        {t(`label.${announceType}`)}
                                        </a>
                                        <span className={classes.separator}>{" > "}</span>
                                    </li>

                                    {announce.property.address.country?.nomFR && (
                                        <li className={`${classes.breadcrumbItem} ${classes.breadcrumbItemLarge}`}>
                                        <a
                                            href={`/${getCountryCode(announce.property.address.country.nomFR.toLowerCase())}/${slugify(announceType)}`}
                                            className={classes.breadcrumbLink}
                                        >
                                           {i18n.language === "fr"
                                                ? announce.property.address.country?.nomFR
                                                : announce.property.address.country?.nomEN}
                                        </a>
                                        <span className={classes.separator}>{" > "}</span>
                                        </li>
                                    )}

                                    {announce.property.address.city?.name && (
                                        <li className={`${classes.breadcrumbItem} ${classes.breadcrumbItemLarge}`}>
                                        <a
                                            href={`/$/${getCountryCode(announce.property.address.country.nomFR.toLowerCase())}/${slugify(announce.property.address.city?.nomFR.toLowerCase())}/${slugify(announceType)}`}
                                            className={classes.breadcrumbLink}
                                        >
                                           {i18n.language === "fr"
                                                ? announce.property.address.city?.nomFR
                                                : announce.property.address.city?.nomEN}
                                        </a>
                                        <span className={classes.separator}>{" > "}</span>
                                        </li>
                                    )}

                                    <li className={`${classes.breadcrumbItem} ${classes.breadcrumbItemLarge}`}>
                                        <span className={classes.propertyName}>{announce.property?.name}</span>
                                    </li>
                                    </Hidden>

                                    {/* For mobile screens: Display breadcrumbs in a vertical column */}
                                    <Hidden smUp> {/* This will hide the content on larger devices */}
                                        <ol className={classes.breadcrumbListMobile}>
                                            <li className={classes.breadcrumbItemMobile}>
                                                <LocationOnOutlinedIcon className={classes.locationIcon} />
                                                <span className={classes.propertyName}>{announce.property?.name}</span>
                                            </li>

                                            {announce.property.address.city?.name && (
                                                <li className={classes.breadcrumbItemMobile}>
                                                    <span className={classes.separator}>{" > "}</span>
                                                    <a
                                                        href={`/$/${getCountryCode(announce.property.address.country.nomFR.toLowerCase())}/${slugify(announce.property.address.city?.nomFR.toLowerCase())}/${slugify(announceType)}`}
                                                        className={classes.breadcrumbLink}
                                                    >
                                                        {i18n.language === "fr"
                                                            ? announce.property.address.city?.nomFR
                                                            : announce.property.address.city?.nomEN}
                                                    </a>
                                                </li>

                                            )}

                                            {announce.property.address.country?.nomEN && (
                                                <li className={classes.breadcrumbItemMobile}>
                                                    <span className={classes.separator}>{" > "}</span>
                                                    <a
                                                        href={`/$/${getCountryCode(announce.property.address.country.nomFR.toLowerCase())}/${slugify(announceType)}`}
                                                        className={classes.breadcrumbLink}
                                                    >
                                                        {i18n.language === "fr"
                                                            ? announce.property.address.country?.nomFR
                                                            : announce.property.address.country?.nomEN}
                                                    </a>
                                                </li>
                                            )}

                                            <li className={classes.breadcrumbItemMobile}>
                                                <span className={classes.separator}>{" > "}</span>
                                                <a href={`/${announceType}`} className={classes.breadcrumbLink}>
                                                    {t(`label.${announceType}`)}
                                                </a>
                                            </li>

                                            <li className={classes.breadcrumbItemMobile}>
                                                <span className={classes.separator}>{" > "}</span>
                                                <a href="/" className={classes.breadcrumbLink}>
                                                    AfriqPnB
                                                </a>
                                            </li>
                                        </ol>
                                    </Hidden>
                                </ol>
                                </nav>
                            </Grid>

                            <Hidden smDown>
                                <Grid item lg={4} md={4} xs={12} sm={12}>
                                    <React.Suspense fallback={<CircularProgress />}>
                                        <ReservationCard
                                            announce={announce}
                                            res_occupe={res_occupe}
                                            searchTypeSearch={searchType}
                                        />
                                    </React.Suspense>
                                </Grid>
                            </Hidden>
                            {(searchType !== "trs" || (searchType === "trs" && announce?.property?.type.name === "Circuit")) ? (
                                // Existing component logic
                                <>
                                    {showToogleButtons && (
                                        <div>
                                            <Hidden mdUp>
                                                <AppBar
                                                    position="fixed"
                                                    className={classes.reservationAppBar}
                                                >
                                                    <Toolbar>
                                                        <Grid
                                                            container
                                                            direction="row"
                                                            alignItems="center"
                                                            justifyContent="space-between"
                                                        >
                                                            <Grid item>
                                                                <div style={{ lineHeight: "22px" }}>
                                                                    {query.get("offer") === "1" ||
                                                                    announce.superOffer === 1 ||
                                                                    jourProm > 0 ? (
                                                                        isNaN(
                                                                            parseInt(
                                                                                priceConvertedProm
                                                                                    .toString()
                                                                                    .replace(
                                                                                        currency.toUpperCase(),
                                                                                        ""
                                                                                    )
                                                                            )
                                                                        ) ||
                                                                        isNaN(
                                                                            parseInt(
                                                                                priceConverted
                                                                                    .toString()
                                                                                    .replace(
                                                                                        currency.toUpperCase(),
                                                                                        ""
                                                                                    )
                                                                            )
                                                                        ) ||
                                                                        priceConverted === 0 ? (
                                                                            <CircularProgress
                                                                                size={16}
                                                                                style={{ color: "#890608" }}
                                                                            />
                                                                        ) : (
                                                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                                                <div>
                                                                                    <span
                                                                                        className={classes.price}
                                                                                        style={{
                                                                                            fontSize: 16,
                                                                                            textDecoration: "line-through rgba(0, 0, 0, 1)",
                                                                                        }}
                                                                                    >
                                                                                        {priceConverted}
                                                                                    </span>{" "}
                                                                                    {searchType === "apts" || searchType === "htls"
                                                                                        ? t("label.par-nuit")
                                                                                        : searchType === "cars"
                                                                                        ? t("label.par-jour")
                                                                                        : null}
                                                                                </div>
                                                                                <div>
                                                                                    <span className={classes.price}>
                                                                                        {priceConvertedProm}
                                                                                    </span>{" "}
                                                                                    {searchType === "apts" || searchType === "htls"
                                                                                        ? t("label.par-nuit")
                                                                                        : searchType === "cars"
                                                                                        ? t("label.par-jour")
                                                                                        : null}
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    ) : priceConverted === 0 ? (
                                                                        <CircularProgress
                                                                            size={16}
                                                                            style={{ color: "#890608" }}
                                                                        />
                                                                    ) : (
                                                                        <>
                                                                            <span className={classes.price}>
                                                                                {priceConverted}
                                                                            </span>{" "}
                                                                            {searchType === "apts" || searchType === "htls"
                                                                                ? t("label.par-nuit")
                                                                                : searchType === "cars"
                                                                                ? t("label.par-jour")
                                                                                : null}
                                                                        </>
                                                                    )}
                                                                </div>
                                                            </Grid>
                                                            <Grid item>
                                                                <Button
                                                                    className={classes.btn_red_appbar}
                                                                    onClick={toogleReservationCard}
                                                                >
                                                                    {t("label.reserver")}
                                                                </Button>
                                                            </Grid>
                                                        </Grid>
                                                    </Toolbar>
                                                </AppBar>
                                            </Hidden>
                                        </div>
                                    )}
                                </>
                            ) : (
                                // Display only the FindCircuitsPopup button if the condition is not met
                                <></>
                            )}
                            <Drawer
                                anchor="bottom"
                                open={showMap}
                                classes={{ paper: classes.drawerPaperMap }}
                                onClose={toogleMap}
                                >
                                {searchType === "trs" && (
                                    <div className={classes.section} style={{ marginBottom: 25 }} id="voir_la_carte">
                                    <h3 style={{ marginBottom: 32 }}>{t("label.localiser-le-lieu")}</h3>
                                    <div className={classes.map}>
                                        {/* Replace Mapbox with Google Maps Embed */}
                                        <GoogleMapsEmbed url={announce.property.trs_embedLink} />
                                    </div>
                                    </div>
                                )}

                                {searchType !== "cars" && searchType !== "rstt" && searchType !== "trs" && (
                                    <div className={classes.section} style={{ marginBottom: 72 }} id="voir_la_carte">
                                    <h3 style={{ marginBottom: 32 }}>{t("label.localiser-le-lieu")}</h3>
                                    {user.role.name === "super admin" ||
                                    user.role.name === "country admin" ||
                                    user.role.name === "admin support" ||
                                    user.role.name === "sales agent" ? (
                                        !isUpdating ? (
                                        <Button
                                            className={classes.btn_red}
                                            onClick={changeLocationHandler}
                                        >
                                            {t("annonce.labels.changer-localisation")}
                                        </Button>
                                        ) : (
                                        <Button
                                            className={classes.btn_red}
                                            onClick={handleUpdate}
                                        >
                                            {t("propriete.buttonSave")}
                                        </Button>
                                        )
                                    ) : null}
                                    {isUpdating && (
                                        <Button
                                        className={classes.btn_cancel}
                                        onClick={cancelUpdateHandler}
                                        >
                                        {t("propriete.labels.annuler-la-modification")}
                                        </Button>
                                    )}
                                    <div className={classes.map}>
                                        {isUpdating ? (
                                        <React.Suspense fallback={<CircularProgress />}>
                                            <Map
                                                width={1230}
                                                height={400}
                                                alignStart={true}
                                                updateLocation
                                                setLocation
                                                handleChange={setNewLocation}
                                                startLongitude={boundaries.Center.lng}
                                                startLatitude={boundaries.Center.lat}
                                                oldLongitude={
                                                newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0
                                                    ? announce.property.location.longitude
                                                    : newGeoLocation.longitude
                                                }
                                                oldLatitude={
                                                newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0
                                                    ? announce.property.location.latitude
                                                    : newGeoLocation.latitude
                                                }
                                                onBoundariesChange={setBoundaries}
                                                startZoom={boundaries.Zoom}
                                                handleNext={handleUpdate}
                                                isSearchingOnMap
                                            />
                                        </React.Suspense>
                                        ) : null}
                                        {!isUpdating ? (
                                        <React.Suspense fallback={<CircularProgress />}>
                                            <Map
                                                width={1230}
                                                height={400}
                                                alignStart={true}
                                                setPin={true}
                                                startLongitude={
                                                newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0
                                                    ? announce.property.location.longitude
                                                    : newGeoLocation.longitude
                                                }
                                                startLatitude={
                                                newGeoLocation.longitude === 0 && newGeoLocation.latitude === 0
                                                    ? announce.property.location.latitude
                                                    : newGeoLocation.latitude
                                                }
                                                onBoundariesChange={setBoundaries}
                                                isSearchingOnMap
                                                startZoom={13}
                                            />
                                        </React.Suspense>
                                        ) : null}
                                    </div>
                                    </div>
                                )}
                            </Drawer>
                            <Drawer
                                anchor="bottom"
                                open={showReservationCard}
                                classes={{ paper: classes.drawerPaperMap }}
                                onClose={toogleReservationCard}
                            >
                                <React.Suspense fallback={<CircularProgress />}>
                                    <ReservationCard
                                        announce={announce}
                                        res_occupe={res_occupe}
                                        searchTypeSearch={searchType}
                                    />
                                </React.Suspense>
                            </Drawer>
                        </Grid>
                    
                        {(user.role.name === ERoles.SUPER_ADMIN ||
                        user.role.name ===
                            ERoles.COUNTRY_ADMIN ||
                        user.role.name ===
                            ERoles.ADMIN_SUPPORT ||
                        user.role.name ===
                            ERoles.SALES_AGENT) && (
                            <Grid container>
                                <Grid item>
                                    <div>
                                    <h4>Download Images</h4>
                                    <DownloadImages images={announce.property.photos.map((photo: any) => photo.fileURL)} />
                                    </div>
                                    {/* Add the QR Code Generator here */}
                                    <div>
                                    <QRCodeGenerator />
                                    </div>
                                </Grid>
                            </Grid>
                        )
                        }         

                    </>
                ) 
                }
            </div>
        </>
    );
}

/*function setErrorMessages(arg0: any) {
    throw new Error("Function not implemented.");
}*/

